var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ceil, cloneDeep, each, filter, find, floor, has, isEmpty, isEqual, isInteger, isNil, isNull, isString, keys, orderBy, remove, reverse, sumBy, toInteger, unset, values, } from 'lodash';
import { MMG_ACTIVITY, MMG_ORDER_PLAN, MMG_PRODUCT_PLAN, GATEWAY, MARKETING_SERVICE, MEMBER_SERVICE, VERSION, DEFAULT_FORMAT, COMBOS, } from './constant';
import { ActivityTypeEnum, DiscountTypeEnum, InteractiveScenes, OffTypeEnum, ProductRelationEnum, PubSubTypeEnum, CouponTypeEnum, StatusEnum, UsePromoCodeStatusEnum, FloorPayTypeEnum, FloorTypeEnum, BoEnum, MemberTypeEnum, CalTimeTypeEnum, ProductTypeEnum, AppTypeEnum, BusinessEnum, ChannelEnum, EatTypeEnum, UseLimitTypeEnum, BalanceDiscountRuleEnum, WhenEffectEnum, } from './enum';
import aes from './lib/aes';
import request from './lib/request';
import { differenceSet, findActivityProduct, prodctToMap, toFixed, traceLog } from './lib/utils';
import storage from './lib/storage';
import dayjs from './lib/dayjs';
import calDesignatedItem from './algorithm/calDesignatedItem';
import calBestItemCoupon from './algorithm/calBestItemCoupon';
import calBestCashCoupon from './algorithm/calBestCashCoupon';
import calNthItemNDiscount from './algorithm/calNthItemNDiscount';
import calFullItemNFree2 from './algorithm/calFullItemNFree2';
import calLadderDiscount from './algorithm/calLadderDiscount';
import calOrderSwapBuy from './algorithm/calOrderSwapBuy';
import calSingleItemSwapBuy from './algorithm/calSingleItemSwapBuy';
import calExpressFeeDiscount from './algorithm/calExpressFeeDiscount';
import upsertItemApportion from './algorithm/upsertItemApportion';
import calGroupBuyCard from './algorithm/calGroupBuyCard';
import todayUsedCntMap from './variable/todayUsedCntMap';
import getEnableActivityByType from './algorithm/getEnableActivityByType';
import calProduct from './algorithm/calProduct';
/**
 * 营销计算器
 */
export default class Mpc {
    constructor() {
        this.activities = [];
        this.timeouts = {};
        this.concessionListeners = {}; // 监听事件 // menu_list:菜单, order_settlement 订单
        this.inputDatas = {}; // 餐品数据
        this.inited = false;
        this.runTask = false; // 运行了定时器任务
        this.lastRunTime = 0; // 最后一次运行时间
        this.isGetRechargeCouponByIds = false;
    }
    /**
     * 初始化
     * @param opt
     */
    init(opt) {
        return __awaiter(this, void 0, void 0, function* () {
            if (opt.domain) {
                this.domian = opt.domain;
            }
            if (isString(opt.proxyHost)) {
                this.proxyHost = opt.proxyHost;
            }
            if (opt.timeZone) {
                this.timeZone = opt.timeZone.replace(/"/g, '');
                dayjs.tz.setDefault(this.timeZone);
            }
            if (opt.token) {
                this.token = opt.token;
            }
            if (!this.token) {
                this.token = storage.getItem('ls.token.' + opt.brandId) || '';
            }
            if (opt.bo) {
                this.bo = opt.bo;
            }
            if (opt.userPoint) {
                this.userPoint = opt.userPoint;
            }
            this.canUseMmg = has(opt, 'canUseMmg') ? opt === null || opt === void 0 ? void 0 : opt.canUseMmg : true;
            if (opt.appVersion) {
                this.appVersion = opt.appVersion;
            }
            request.interceptors.request.use((config) => {
                const headers = config.headers;
                if (this.timeZone) {
                    headers.timezone = this.timeZone;
                }
                if (this.bo) {
                    headers.bo = this.bo;
                }
                if (this.i18n) {
                    headers.i18n = this.i18n;
                }
                if (this.token) {
                    headers.token = this.token;
                }
                if (this.appType) {
                    headers.appType = this.appType;
                }
                if (this.userPoint) {
                    headers.userPoint = this.userPoint;
                }
                if (this.appVersion) {
                    headers.appVersion = this.appVersion;
                }
                return Object.assign(Object.assign({}, config), { headers: headers });
            }, (error) => Promise.reject(error));
            this.brandId = opt.brandId;
            this.storeId = opt.storeId || 0;
            if (opt.appType) {
                this.appType = opt.appType;
            }
            if (opt.eatType) {
                this.eatType = opt.eatType;
            }
            if (opt.channel) {
                this.channel = opt.channel;
            }
            if (opt.PubSub) {
                opt.PubSub.subscribe(MMG_ACTIVITY, (data) => {
                    // 订阅kds更新事件
                    this === null || this === void 0 ? void 0 : this.reCall(true, data.pubsubType);
                });
            }
            if (!this.runTask) {
                setInterval(() => {
                    if (dayjs().valueOf() - this.lastRunTime > 60000) {
                        // 60秒之内不重复调用
                        this.refreshActivity(false);
                    }
                    this.lastRunTime = dayjs().valueOf();
                }, (opt === null || opt === void 0 ? void 0 : opt.taskTime) || 600000); // 10分钟拉一次
                this.runTask = true;
            }
            return this === null || this === void 0 ? void 0 : this.reCall(false).then((resp) => {
                this.inited = true;
                this.reCallListeners();
                return resp;
            });
        });
    }
    /**
     * 获取营销服务地址
     */
    getPosService() {
        if (isString(this.proxyHost)) {
            return this.proxyHost + '/' + MARKETING_SERVICE;
        }
        return GATEWAY + this.domian + '/' + MARKETING_SERVICE;
    }
    /*
     * 获取会员服务地址
     */
    getMobileService() {
        if (isString(this.proxyHost)) {
            return this.proxyHost + '/mobile-' + MEMBER_SERVICE;
        }
        return GATEWAY + this.domian + '/mobile-' + MEMBER_SERVICE;
    }
    getServiceUrl() {
        if (this.appType === AppTypeEnum.Mobile) {
            return this.getMobileService();
        }
        return this.getPosService();
    }
    /**
     * 设置 eatType
     * @param eatType
     */
    switchEatType(eatType) {
        if (this.eatType !== eatType) {
            this.beforeUpdateEatType(eatType);
            if (this.inited) {
                this.reCallListeners();
            }
        }
    }
    /**
     * 设置 channel
     * @param channel
     */
    switchChannel(channel) {
        if (this.channel !== channel) {
            this.channel = channel;
            if (this.inited) {
                this.reCallListeners();
            }
        }
    }
    beforeUpdateEatType(eatType) {
        var _a, _b;
        if ((eatType !== EatTypeEnum.Mall && this.eatType === EatTypeEnum.Mall) ||
            (eatType === EatTypeEnum.Mall && this.eatType !== EatTypeEnum.Mall)) {
            this.eatType = eatType;
            let sceneName = InteractiveScenes.ORDER_SETTLEMENT;
            if (this.eatType === EatTypeEnum.Mall) {
                sceneName = InteractiveScenes.MALL_ORDER_SETTLEMENT;
            }
            this.handleAvailableCards(((_b = (_a = this === null || this === void 0 ? void 0 : this.inputDatas[sceneName]) === null || _a === void 0 ? void 0 : _a.opt) === null || _b === void 0 ? void 0 : _b.onlyBalancePay) || false);
        }
        else {
            this.eatType = eatType;
        }
    }
    /**
     * 重新设置 opt
     * @param opt
     */
    setOption(opt) {
        let toReCallListeners = false;
        if (opt.eatType && this.eatType !== opt.eatType) {
            this.beforeUpdateEatType(opt.eatType);
            toReCallListeners = true;
        }
        if (opt.appType && this.appType !== opt.appType) {
            this.appType = opt.appType;
        }
        if (opt.channel && this.channel !== opt.channel) {
            this.channel = opt.channel;
            toReCallListeners = true;
        }
        if (toReCallListeners && this.inited) {
            this.reCallListeners();
        }
    }
    /**
     * 设置时区
     * @param timeZone
     */
    setTimeZone(timeZone) {
        this.timeZone = timeZone;
        dayjs.tz.setDefault(timeZone);
        // this.refreshActivity(true);
    }
    /**
     * 重新计算
     * @param isCall 是否回调
     */
    reCall(isCall = true, pubsubType = '') {
        return __awaiter(this, void 0, void 0, function* () {
            if (pubsubType === PubSubTypeEnum.Plan) {
                yield this.storePlan();
            }
            else if (pubsubType === PubSubTypeEnum.Activity) {
                yield this.refreshActivity(false);
            }
            else if (pubsubType === PubSubTypeEnum.MemberPrice) {
                yield this.getMemberPrice(false);
            }
            else if (pubsubType === PubSubTypeEnum.Config) {
                yield this.getMarketingConfig();
            }
            else {
                yield this.combineRequest();
            }
            if (isCall) {
                this.reCallListeners();
            }
            return this.activities;
        });
    }
    /**
     * 重新调用回调
     */
    reCallListeners() {
        each(this.concessionListeners, (listener, name) => {
            if (this.eatType === EatTypeEnum.Mall &&
                (name === InteractiveScenes.ORDER_SETTLEMENT || name === InteractiveScenes.MENU_LIST)) {
                return true;
            }
            else if (this.eatType !== EatTypeEnum.Mall &&
                (name === InteractiveScenes.MALL_ORDER_SETTLEMENT || name === InteractiveScenes.MALL_MENU_LIST)) {
                return true;
            }
            if (this.inputDatas[name] && this.inputDatas[name].products) {
                if (name === InteractiveScenes.ORDER_SETTLEMENT || name === InteractiveScenes.MALL_ORDER_SETTLEMENT) {
                    this.calOrder(cloneDeep(this.inputDatas[name].products), Object.assign(Object.assign({}, this.inputDatas[name].opt), { isNeedNotice: true }));
                }
                else {
                    calProduct({
                        canUseMmg: this.canUseMmg,
                        inited: this.inited,
                        eatType: this.eatType,
                        concessionListeners: this.concessionListeners,
                        timeZone: this.timeZone,
                        optMemberCard: this.optMemberCard || null,
                        productPlan: this.productPlan,
                        memberPriceMap: this.memberPriceMap,
                        memberPricePlanName: this.memberPricePlanName,
                        memberPricePlanId: this.memberPricePlanId,
                        onlyInSideMemberPrice: this.onlyInSideMemberPrice,
                        mallMemberPriceMap: this.mallMemberPriceMap,
                        mallMemberPricePlanName: this.mallMemberPricePlanName,
                        mallMemberPricePlanId: this.mallMemberPricePlanId,
                        mallOnlyInSideMemberPrice: this.mallOnlyInSideMemberPrice,
                        orderPlan: this.orderPlan,
                        appType: this.appType,
                        channel: this.channel,
                        activities: this.activities,
                        config: this.config,
                        availableCards: this.availableCards || [],
                        addTimeout: this.addTimeout,
                    }, this.inputDatas[name].products, this.inputDatas[name].opt);
                }
            }
        });
    }
    /**
     * 更新菜单
     * @param products
     */
    parseInputData(name, products, opt) {
        this.inputDatas[name] = {
            products: cloneDeep(products),
            opt: cloneDeep(opt),
        };
        if (name === InteractiveScenes.ORDER_SETTLEMENT || name === InteractiveScenes.MALL_ORDER_SETTLEMENT) {
            return this.calOrder(products, opt);
        }
        else {
            return calProduct({
                canUseMmg: this.canUseMmg,
                inited: this.inited,
                eatType: this.eatType,
                concessionListeners: this.concessionListeners,
                timeZone: this.timeZone,
                optMemberCard: this.optMemberCard || null,
                productPlan: this.productPlan,
                memberPriceMap: this.memberPriceMap,
                memberPricePlanName: this.memberPricePlanName,
                memberPricePlanId: this.memberPricePlanId,
                onlyInSideMemberPrice: this.onlyInSideMemberPrice,
                mallMemberPriceMap: this.mallMemberPriceMap,
                mallMemberPricePlanName: this.mallMemberPricePlanName,
                mallMemberPricePlanId: this.mallMemberPricePlanId,
                mallOnlyInSideMemberPrice: this.mallOnlyInSideMemberPrice,
                orderPlan: this.orderPlan,
                appType: this.appType,
                channel: this.channel,
                activities: this.activities,
                config: this.config,
                availableCards: this.availableCards || [],
                addTimeout: this.addTimeout,
            }, products, opt);
        }
    }
    /**
     * 添加监听事件
     * @param name
     * @param listener
     */
    addConcessionListener(name, listener) {
        if (listener) {
            this.concessionListeners[name] = listener;
        }
    }
    /**
     * 可用的活动
     */
    refreshActivity(notice = false, activities) {
        return __awaiter(this, void 0, void 0, function* () {
            this.lastRunTime = dayjs().valueOf();
            if (!this.domian) {
                return;
            }
            if (!activities) {
                const res = yield request.get(this.getServiceUrl() + '/pos/enableActitity', {
                    params: { brandId: this.brandId, storeId: this.storeId || 0, appType: this.appType },
                    headers: this.getRequestHeaders(),
                });
                activities = res === null || res === void 0 ? void 0 : res.result;
            }
            if (!notice && !isEqual(this.activities, activities)) {
                notice = true;
            }
            this.activities = activities;
            this.clearTimeout();
            const nowTime = dayjs().format(DEFAULT_FORMAT); // 现在的时间
            each(this.activities, (activity) => {
                if (activity.startTime && activity.startTime > nowTime) {
                    this.addTimeout(activity.startTime);
                }
                if (activity.endTime && activity.endTime > nowTime) {
                    this.addTimeout(activity.endTime);
                }
                activity.productMap = {};
                each(activity.products, (product) => {
                    !product.cnt && (product.cnt = 0);
                    unset(product, 'isDel');
                    let key = '';
                    if (product.categoryNo && !product.productNo && !product.scaleNo) {
                        key = product.categoryNo;
                    }
                    else if (product.productNo && !product.scaleNo) {
                        key = product.productNo;
                    }
                    else if (product.productNo && product.scaleNo) {
                        // 单规格
                        if (product.scaleNo === '0') {
                            activity.productMap[product.productNo] = product;
                        }
                        key = [product.productNo, product.scaleNo].join('_');
                    }
                    activity.productMap[key] = product;
                });
                if (activity.type === ActivityTypeEnum.SingleItemDiscount) {
                    unset(activity, 'products');
                }
                if (activity.extra) {
                    activity.extra.triggerProductMap = {};
                    this.handleTrigger(activity, 'triggerCombo');
                    this.handleTrigger(activity, 'triggerProducts');
                }
                if (activity.promoCode) {
                    activity.promoCode = aes.decrypt(activity.promoCode);
                }
            });
            // 活动更新了在通知
            if (notice && this.concessionListeners) {
                let nemuName = InteractiveScenes.MENU_LIST;
                let orderName = InteractiveScenes.ORDER_SETTLEMENT;
                if (this.eatType === EatTypeEnum.Mall) {
                    nemuName = InteractiveScenes.MALL_MENU_LIST;
                    orderName = InteractiveScenes.MALL_ORDER_SETTLEMENT;
                }
                if (this.inputDatas[orderName] &&
                    this.inputDatas[orderName].products &&
                    this.inputDatas[orderName].products.length > 0) {
                    this.calOrder([...this.inputDatas[orderName].products], Object.assign(Object.assign({}, this.inputDatas[orderName].opt), { isNeedNotice: true }));
                }
                if (this.inputDatas[nemuName]) {
                    calProduct({
                        canUseMmg: this.canUseMmg,
                        inited: this.inited,
                        eatType: this.eatType,
                        concessionListeners: this.concessionListeners,
                        timeZone: this.timeZone,
                        optMemberCard: this.optMemberCard || null,
                        productPlan: this.productPlan,
                        memberPriceMap: this.memberPriceMap,
                        memberPricePlanName: this.memberPricePlanName,
                        memberPricePlanId: this.memberPricePlanId,
                        onlyInSideMemberPrice: this.onlyInSideMemberPrice,
                        mallMemberPriceMap: this.mallMemberPriceMap,
                        mallMemberPricePlanName: this.mallMemberPricePlanName,
                        mallMemberPricePlanId: this.mallMemberPricePlanId,
                        mallOnlyInSideMemberPrice: this.mallOnlyInSideMemberPrice,
                        orderPlan: this.orderPlan,
                        appType: this.appType,
                        channel: this.channel,
                        activities: this.activities,
                        config: this.config,
                        availableCards: this.availableCards || [],
                        addTimeout: this.addTimeout,
                    }, this.inputDatas[nemuName].products, this.inputDatas[nemuName].opt);
                }
            }
            return this.activities;
        });
    }
    /**
     * 触发餐品处理
     */
    handleTrigger(activity, triggerKey) {
        if (activity.extra) {
            if (activity.extra[triggerKey]) {
                each(activity.extra[triggerKey], (product) => {
                    let key = '';
                    if (product.categoryNo && !product.productNo && !product.scaleNo) {
                        key = product.categoryNo;
                    }
                    else if (product.productNo && !product.scaleNo) {
                        key = product.productNo;
                    }
                    else if (product.productNo && product.scaleNo) {
                        key = [product.productNo, product.scaleNo].join('_');
                    }
                    activity.extra && (activity.extra.triggerProductMap[key] = product);
                });
                unset(activity.extra, triggerKey);
            }
        }
    }
    // 全额全部支付的结果
    balancePayCalOrder(products, opt) {
        const optClone = cloneDeep(opt);
        const productsClone = cloneDeep(products);
        if (optClone) {
            optClone.onlyBalancePay = true;
        }
        return this.actualCalOrder(productsClone, optClone);
    }
    // 不是余额全部支付的结果
    noBalancePayCalOrder(products, opt) {
        const optClone = cloneDeep(opt);
        const productsClone = cloneDeep(products);
        if (optClone) {
            optClone.onlyBalancePay = false;
        }
        return this.actualCalOrder(productsClone, optClone);
    }
    actualCalOrder(products, opt) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15;
        const originOptMemberCard = cloneDeep(this.optMemberCard);
        const cloneMember = cloneDeep(this.member);
        this.handleAvailableCards((opt === null || opt === void 0 ? void 0 : opt.onlyBalancePay) || false, (opt === null || opt === void 0 ? void 0 : opt.clearMemberCard) || false);
        // if (!opt || !opt.onlyBalancePay) {
        //   this.handleAvailableCards(
        //     false,
        //     opt?.clearMemberCard || (has(opt, 'onlyBalancePay') && opt?.onlyBalancePay === false),
        //   );
        // }
        let canMockCardRechargeSendCoupon = false;
        let nowTime = dayjs().format(DEFAULT_FORMAT); // 现在的时间
        const mockCoupons = [];
        // 模拟充值的时候
        if ((opt === null || opt === void 0 ? void 0 : opt.mockCardRechargeId) && this.optMemberCard) {
            opt.selectCouponIds = [];
            if ((_a = this.optMemberCard) === null || _a === void 0 ? void 0 : _a.recharges) {
                // 模拟充值加上余额
                each(this.optMemberCard.recharges, (recharge) => {
                    var _a, _b;
                    if (opt === null || opt === void 0 ? void 0 : opt.mockCardRechargeId) {
                        if ((opt === null || opt === void 0 ? void 0 : opt.mockCardRechargeId) === recharge.cardRechargeId) {
                            this.optMemberCard &&
                                (this.optMemberCard.balance = (((_a = this.optMemberCard) === null || _a === void 0 ? void 0 : _a.balance) || 0) + recharge.money + recharge.moneyGive);
                            if (!((_b = this.member) === null || _b === void 0 ? void 0 : _b.coupons)) {
                                this.member && (this.member.coupons = {});
                            }
                            each(recharge.coupons, (coupon, index) => {
                                var _a, _b;
                                const couponConfig = (((_a = this.member) === null || _a === void 0 ? void 0 : _a.mockCouponMap) && ((_b = this.member) === null || _b === void 0 ? void 0 : _b.mockCouponMap[coupon.couponId])) || {};
                                if (couponConfig.whenEffect === WhenEffectEnum.Today ||
                                    (couponConfig.whenEffect === WhenEffectEnum.Specify &&
                                        couponConfig.startTime <= nowTime &&
                                        nowTime >= couponConfig.endTime)) {
                                    canMockCardRechargeSendCoupon = true;
                                    for (let i = 0; i < coupon.couponCnt; i++) {
                                        const key = [coupon.couponId, index, i].join('');
                                        const mockCoupon = cloneDeep(couponConfig);
                                        mockCoupon.memberCouponId = key;
                                        mockCoupon.isMockRecharge = true;
                                        if (couponConfig.whenEffect === WhenEffectEnum.Today) {
                                            mockCoupon.startTime = dayjs().startOf('date').format(DEFAULT_FORMAT);
                                            mockCoupon.endTime = dayjs(nowTime)
                                                .add(couponConfig.effectDay ? couponConfig.effectDay : 365000, 'd')
                                                .format(DEFAULT_FORMAT);
                                        }
                                        mockCoupons.push(mockCoupon);
                                    }
                                }
                            });
                            return;
                        }
                    }
                });
            }
        }
        else if ((opt === null || opt === void 0 ? void 0 : opt.mockCardRechargeMoney) && opt.mockCardRechargeMoney > 0 && this.optMemberCard) {
            this.optMemberCard.balance = (((_b = this.optMemberCard) === null || _b === void 0 ? void 0 : _b.balance) || 0) + opt.mockCardRechargeMoney;
        }
        const memberItemCouponMap = {};
        const memberCouponMap = {};
        const couponsConfigMap = ((_c = this.member) === null || _c === void 0 ? void 0 : _c.couponsConfigMap) || {};
        let addTimes = [];
        let nowDay = dayjs().day();
        let nowDate = dayjs().date();
        if (((_d = this.config) === null || _d === void 0 ? void 0 : _d.discountCalTime) === CalTimeTypeEnum.OrderTime) {
            nowTime = (opt === null || opt === void 0 ? void 0 : opt.addTime) || nowTime;
            if (opt === null || opt === void 0 ? void 0 : opt.startTime) {
                nowTime = opt === null || opt === void 0 ? void 0 : opt.startTime;
                opt.addTime = nowTime;
            }
        }
        nowDay = dayjs(nowTime).day();
        nowDate = dayjs(nowTime).date();
        let usePromoCodeStatus = UsePromoCodeStatusEnum.Unused;
        const parentProductMap = {};
        const productMap = {};
        // 参加满送的换购物
        const alearedJoinFullItemPks = [];
        const itemMap = {};
        const newProducts = [];
        const expressProducts = [];
        let boxProduct;
        const enablePromoCodeActivity = []; // 生效的promoCode活动ID
        let originFee = 0; // 订单的原始金额
        each(products, (product) => {
            var _a, _b, _c;
            originFee += (product.price + (product.memberPrice || 0)) * (product.cnt || 0);
            const id = product.pk || product.productNo + '_' + product.scaleNo;
            if (product.orderDetailId && (!product.orderParentId || product.orderParentId === '0')) {
                parentProductMap[product.orderDetailId] = product;
            }
            if (product.orderDetailId &&
                product.orderParentId &&
                product.orderParentId == '0' &&
                product.orderDisocuntList &&
                product.orderDisocuntList.length > 0) {
                // 满送固化的数据
                const fullItemNFreeDisouncts = filter(product.orderDisocuntList, (orderDisocunt) => {
                    var _a;
                    if (orderDisocunt.discountType === ActivityTypeEnum.FullItemNFreePromoCode) {
                        usePromoCodeStatus = UsePromoCodeStatusEnum.Effective;
                        enablePromoCodeActivity.push(orderDisocunt.activityId);
                        return true;
                    }
                    if (orderDisocunt.discountType.includes('PromoCode')) {
                        try {
                            const activityContent = JSON.parse(orderDisocunt.activityContent);
                            if (activityContent &&
                                activityContent.promoCode &&
                                ((_a = activityContent.promoCode) === null || _a === void 0 ? void 0 : _a.length) >= 8 &&
                                activityContent.activityPromoCodeId) {
                                // 一码一用的优惠码
                                each(this.activities, (activity) => {
                                    if (activity.activityId === toInteger(orderDisocunt.activityId)) {
                                        activity.promoCode = activityContent.promoCode;
                                    }
                                });
                            }
                        }
                        catch (e) { }
                    }
                    return orderDisocunt.discountType === ActivityTypeEnum.FullItemNFree;
                });
                each(fullItemNFreeDisouncts, (fullItemNFreeDisounct) => {
                    const activityContentObj = JSON.parse((fullItemNFreeDisounct === null || fullItemNFreeDisounct === void 0 ? void 0 : fullItemNFreeDisounct.activityContent) || '{}');
                    (activityContentObj === null || activityContentObj === void 0 ? void 0 : activityContentObj.relatedPks) && alearedJoinFullItemPks.push(...activityContentObj.relatedPks);
                    if (!itemMap[id]) {
                        itemMap[id] = {
                            items: [],
                            itemAllOff: 0,
                        };
                    }
                    product.isFullItemNFree = true;
                    itemMap[id].items.push(Object.assign(Object.assign({}, product), { off: fullItemNFreeDisounct.fee, offId: fullItemNFreeDisounct.activityId, offTip: fullItemNFreeDisounct.discountName, offType: OffTypeEnum.Activity, isIncludeModifier: activityContentObj.isIncludeModifier || false, relatedPks: activityContentObj === null || activityContentObj === void 0 ? void 0 : activityContentObj.relatedPks }));
                    itemMap[id].itemAllOff += fullItemNFreeDisounct.fee;
                });
            }
            product.productAndModifierPrice = toFixed(product.price + ((_a = product.modifierPrice) !== null && _a !== void 0 ? _a : 0));
            // if (product.type === ProductTypeEnum.OptionalCombo && product.addPrice && product.price >= product.addPrice) {
            //   product.productAndModifierPrice = toFixed(product.productAndModifierPrice - product.addPrice);
            //   product.price = toFixed(product.price - product.addPrice);
            // }
            if (((_b = this.config) === null || _b === void 0 ? void 0 : _b.discountCalTime) === CalTimeTypeEnum.PayTime) {
                product.addTime = nowTime;
            }
            if (((_c = this.config) === null || _c === void 0 ? void 0 : _c.discountCalTime) === CalTimeTypeEnum.OrderTimeIncludeStartTime && (opt === null || opt === void 0 ? void 0 : opt.startTime)) {
                product.addTime = opt.addTime || nowTime;
            }
            if (!product.addTime) {
                product.addTime = nowTime;
            }
            addTimes.push(product.addTime);
            if (product.type !== ProductTypeEnum.Express &&
                product.type !== ProductTypeEnum.Box &&
                product.productAndModifierPrice > 0) {
                productMap[id] = product;
                newProducts.push(product);
            }
            else if (product.type === ProductTypeEnum.Express) {
                expressProducts.push(product);
            }
            else if (product.type === ProductTypeEnum.Box) {
                boxProduct = product;
            }
        });
        products = newProducts;
        opt = Object.assign(Object.assign({}, opt), { addTimes });
        // 单品换购活动数据
        const singleItemSwapBuyActivities = getEnableActivityByType(this, [ActivityTypeEnum.SingleItemSwapBuy], opt);
        const singleItemSwapBuyMap = {};
        const calSingleItemSwapBuyRes = calSingleItemSwapBuy({
            products,
            parentProductMap,
            usePromoCodeStatus,
            singleItemSwapBuyActivities,
            enablePromoCodeActivity,
            singleItemSwapBuyMap,
        });
        usePromoCodeStatus = calSingleItemSwapBuyRes.usePromoCodeStatus;
        if (!(opt === null || opt === void 0 ? void 0 : opt.isSelectCoupon)) {
            (opt === null || opt === void 0 ? void 0 : opt.selectCouponIds) && (opt.selectCouponIds = []);
        }
        const cloneMemberCoupon = cloneDeep(((_e = this.member) === null || _e === void 0 ? void 0 : _e.coupons) || {});
        if (mockCoupons.length > 0 && cloneMemberCoupon) {
            each(mockCoupons, (coupon) => {
                cloneMemberCoupon[coupon.memberCouponId] = coupon;
            });
        }
        // const orderCoupons: Coupon[] = []; // 订单优惠券
        const cashCoupons = []; // 现金优惠券
        const mockCashCoupons = []; // 现金优惠券
        const designateCoupons = []; // 指定满减优惠券
        const joinDesignateCoupons = []; // 能参加活动的指定满减优惠券
        const ladderCoupons = []; // 阶梯优惠券
        const joinLadderCoupons = []; // 能参加阶梯优惠券
        // const joinLadderCouponIds: number[] = []; // 能参加阶梯优惠券id
        const expressCoupons = []; // 配送优惠券
        let isSelectDesignateCoupon = false;
        let isSelectLadderCoupon = false;
        let isSelectItemCoupon = false;
        /** 优惠券的今天使用数量 */
        todayUsedCntMap.init();
        if (cloneMemberCoupon) {
            const canUseDesignateCouponIds = [];
            const notCanUseDesignateCouponIds = [];
            each(cloneMemberCoupon, (coupon) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
                if (!todayUsedCntMap.has(coupon.couponId)) {
                    if ((coupon === null || coupon === void 0 ? void 0 : coupon.useLimitType) === UseLimitTypeEnum.EveryOrder) {
                        todayUsedCntMap.initOne(coupon.couponId, 0);
                    }
                    else {
                        todayUsedCntMap.initOne(coupon.couponId, (coupon === null || coupon === void 0 ? void 0 : coupon.todayUsedCnt) || 0);
                    }
                }
                if (coupon.type === CouponTypeEnum.Item) {
                    if ([CalTimeTypeEnum.OrderTime, CalTimeTypeEnum.OrderTimeIncludeStartTime].includes((_a = this.config) === null || _a === void 0 ? void 0 : _a.discountCalTime)) {
                        nowTime = find(addTimes, (addTime) => addTime >= coupon.startTime && addTime <= coupon.endTime) || nowTime;
                    }
                }
                else {
                    if ([CalTimeTypeEnum.OrderTime, CalTimeTypeEnum.OrderTimeIncludeStartTime].includes((_b = this.config) === null || _b === void 0 ? void 0 : _b.discountCalTime)) {
                        nowTime = (opt === null || opt === void 0 ? void 0 : opt.addTime) || nowTime;
                    }
                }
                //  优惠券基础属性能否使用
                let canUse = false;
                if ((((_c = coupon.channelEatType) === null || _c === void 0 ? void 0 : _c.isAll) ||
                    ((_d = coupon.channelEatType) === null || _d === void 0 ? void 0 : _d.channels.find((channel) => (channel === null || channel === void 0 ? void 0 : channel.key) === this.channel && channel.eatTypes.includes(this.eatType) && channel.enable))) &&
                    nowTime >= coupon.startTime &&
                    nowTime <= coupon.endTime && // 在有效期的时间内
                    (coupon.isAllTime ||
                        ((coupon.timeRangeType === 'week' || isNull(coupon.timeRangeType)) && ((_e = coupon.days) === null || _e === void 0 ? void 0 : _e.includes(nowDay))) ||
                        (coupon.timeRangeType === 'month' && ((_f = coupon.days) === null || _f === void 0 ? void 0 : _f.includes(nowDate)))) &&
                    (coupon.isAllStore || ((_g = couponsConfigMap[coupon.couponId].storeIds) === null || _g === void 0 ? void 0 : _g.includes(this.storeId))) &&
                    (((!coupon.business || coupon.business === BusinessEnum.Meal) && this.eatType !== EatTypeEnum.Mall) ||
                        (coupon.business === BusinessEnum.Mall && this.eatType === EatTypeEnum.Mall))) {
                    if (!coupon.isAllTime) {
                        if (coupon.timeRangeType === 'month') {
                            if ((_h = coupon.days) === null || _h === void 0 ? void 0 : _h.includes(nowDate)) {
                                canUse = true;
                            }
                        }
                        else {
                            const nowHourTime = dayjs(nowTime).format('HH:mm');
                            each(coupon.timeRanges, (timeRange) => {
                                if (timeRange.isOpen && timeRange.weekDay === nowDay) {
                                    each(timeRange.ranges, (range) => {
                                        if (range.startTime <= nowHourTime && range.endTime >= nowHourTime) {
                                            canUse = true;
                                        }
                                    });
                                }
                            });
                        }
                    }
                    else {
                        canUse = true;
                    }
                    if (coupon.type === CouponTypeEnum.Order && coupon.productRelation === ProductRelationEnum.Excluded) {
                        let hasExcluded = false;
                        each(products, (product) => {
                            const findProduct = findActivityProduct(couponsConfigMap[coupon.couponId].productMap, product);
                            if (findProduct) {
                                hasExcluded = true;
                            }
                        });
                        if (hasExcluded) {
                            canUse = false;
                        }
                    }
                    else if (coupon.type === CouponTypeEnum.Item) {
                        if (calSingleItemSwapBuyRes &&
                            ((_j = calSingleItemSwapBuyRes === null || calSingleItemSwapBuyRes === void 0 ? void 0 : calSingleItemSwapBuyRes.allSwapBuyProducts) === null || _j === void 0 ? void 0 : _j.length) > 0 &&
                            calSingleItemSwapBuyRes.isOverlySingleItemDiscount === false) {
                            canUse = false;
                        }
                        if (canUse) {
                            canUse = false;
                            each(products, (product) => {
                                const findProduct = findActivityProduct(couponsConfigMap[coupon.couponId].productMap, product);
                                if (findProduct) {
                                    canUse = true;
                                    return;
                                }
                            });
                        }
                    }
                }
                if (canUse) {
                    if ((coupon === null || coupon === void 0 ? void 0 : coupon.useLimitType) === UseLimitTypeEnum.EveryDay) {
                        if (todayUsedCntMap.get(coupon.couponId) >= (coupon.useLimitCnt || 1)) {
                            canUse = false;
                        }
                    }
                }
                coupon.canUse = canUse;
                if (coupon.type === CouponTypeEnum.Item) {
                    memberItemCouponMap[coupon.memberCouponId] = coupon;
                }
                else if (coupon.type === CouponTypeEnum.Order ||
                    coupon.type === CouponTypeEnum.Cash ||
                    coupon.type === CouponTypeEnum.Express) {
                    memberCouponMap[coupon.memberCouponId] = coupon;
                    if (coupon.type === CouponTypeEnum.Express) {
                        expressCoupons.push(coupon);
                    }
                }
                else if (coupon.type === CouponTypeEnum.Designate) {
                    if (canUse) {
                        if ((opt === null || opt === void 0 ? void 0 : opt.isSelectCoupon) && opt.selectCouponIds && opt.selectCouponIds.length > 0) {
                            if ((_k = opt.selectCouponIds) === null || _k === void 0 ? void 0 : _k.includes(coupon.memberCouponId)) {
                                joinDesignateCoupons.push(coupon);
                                isSelectDesignateCoupon = true;
                            }
                        }
                        else {
                            canUse = false;
                            if (canUseDesignateCouponIds.includes(coupon.couponId)) {
                                canUse = true;
                            }
                            else if (notCanUseDesignateCouponIds.includes(coupon.couponId)) {
                                canUse = false;
                            }
                            else {
                                each(productMap, (product) => {
                                    const findProduct = findActivityProduct(couponsConfigMap[coupon.couponId].productMap, product);
                                    if ((coupon.productRelation === ProductRelationEnum.All &&
                                        (product.type === ProductTypeEnum.Product || product.type === ProductTypeEnum.MallProduct)) ||
                                        (coupon.productComboRelation === ProductRelationEnum.All && COMBOS.includes(product.type))) {
                                        canUse = true;
                                        return;
                                    }
                                    else {
                                        if (findProduct &&
                                            (((product.type === ProductTypeEnum.Product || product.type === ProductTypeEnum.MallProduct) &&
                                                coupon.productRelation === ProductRelationEnum.Included) ||
                                                (COMBOS.includes(product.type) && coupon.productComboRelation === ProductRelationEnum.Included))) {
                                            canUse = true;
                                            return;
                                        }
                                        else if (!findProduct &&
                                            (((product.type === ProductTypeEnum.Product || product.type === ProductTypeEnum.MallProduct) &&
                                                coupon.productRelation === ProductRelationEnum.Excluded) ||
                                                (COMBOS.includes(product.type) && coupon.productComboRelation === ProductRelationEnum.Excluded))) {
                                            canUse = true;
                                            return;
                                        }
                                    }
                                });
                            }
                            if (canUse) {
                                joinDesignateCoupons.push(coupon);
                                canUseDesignateCouponIds.push(coupon.couponId);
                            }
                            else {
                                coupon.status = StatusEnum.Disable;
                                coupon.isSelect = false;
                                coupon.canUse = false;
                                notCanUseDesignateCouponIds.push(coupon.couponId);
                            }
                        }
                    }
                    else {
                        coupon.isSelect = false;
                        coupon.status = StatusEnum.Disable;
                    }
                    designateCoupons.push(coupon);
                    memberCouponMap[coupon.memberCouponId] = coupon;
                }
                else if (coupon.type === CouponTypeEnum.Ladder) {
                    if (canUse) {
                        coupon.averageDiscountValue =
                            sumBy(filter((_l = couponsConfigMap[coupon.couponId].extra) === null || _l === void 0 ? void 0 : _l.ladderDiscount, { enable: true }), 'discountValue') / ((_o = (_m = couponsConfigMap[coupon.couponId].extra) === null || _m === void 0 ? void 0 : _m.ladderDiscount.length) !== null && _o !== void 0 ? _o : 1);
                        if (opt === null || opt === void 0 ? void 0 : opt.isSelectCoupon) {
                            if ((_p = opt.selectCouponIds) === null || _p === void 0 ? void 0 : _p.includes(coupon.memberCouponId)) {
                                joinLadderCoupons.push(coupon);
                                isSelectLadderCoupon = true;
                                // joinLadderCouponIds.push(coupon.memberCouponId);
                            }
                        }
                        else {
                            joinLadderCoupons.push(coupon);
                            // joinLadderCouponIds.push(coupon.memberCouponId);
                        }
                    }
                    else {
                        coupon.isSelect = false;
                        coupon.status = StatusEnum.Disable;
                    }
                    ladderCoupons.push(coupon);
                    memberCouponMap[coupon.memberCouponId] = coupon;
                }
            });
        }
        let selectItemCouponIds = [];
        let selectItemCouponMap = (opt === null || opt === void 0 ? void 0 : opt.selectItemCouponMap) || {};
        const calSelectItemCouponIds = [];
        // 用户自己选择的优惠券
        if (opt === null || opt === void 0 ? void 0 : opt.isSelectCoupon) {
            const pkCntMap = {};
            const pkMemberIdsMap = {};
            each(selectItemCouponMap, (pk, memberCouponId) => {
                var _a;
                if (!pkCntMap[pk]) {
                    pkCntMap[pk] = 0;
                }
                if (!pkMemberIdsMap[pk]) {
                    pkMemberIdsMap[pk] = [];
                }
                if (pkCntMap[pk] && pkCntMap[pk] >= (((_a = productMap[pk]) === null || _a === void 0 ? void 0 : _a.cnt) || 0)) {
                    delete selectItemCouponMap[pkMemberIdsMap[pk][0]];
                    pkMemberIdsMap[pk].shift();
                }
                pkCntMap[pk]++;
                pkMemberIdsMap[pk].push(memberCouponId);
            });
            selectItemCouponIds = reverse(keys(selectItemCouponMap));
            if (selectItemCouponIds.length > 0) {
                each(selectItemCouponIds, (id) => {
                    const itemCoupon = memberItemCouponMap[id];
                    if (itemCoupon &&
                        ((itemCoupon === null || itemCoupon === void 0 ? void 0 : itemCoupon.useLimitType) === UseLimitTypeEnum.NoLimit ||
                            ((itemCoupon === null || itemCoupon === void 0 ? void 0 : itemCoupon.useLimitCnt) || 1) > todayUsedCntMap.get(itemCoupon === null || itemCoupon === void 0 ? void 0 : itemCoupon.couponId))) {
                        todayUsedCntMap.increase(itemCoupon.couponId);
                        isSelectItemCoupon = true;
                        (itemCoupon === null || itemCoupon === void 0 ? void 0 : itemCoupon.canUse) && calSelectItemCouponIds.unshift(toInteger(id));
                    }
                    else {
                        delete selectItemCouponMap[id];
                    }
                });
            }
        }
        else {
            selectItemCouponMap = {};
            each(memberItemCouponMap, (v, key) => {
                v.canUse && calSelectItemCouponIds.push(toInteger(key));
            });
        }
        const notJoinFullItemPks = [];
        if (calSelectItemCouponIds.length > 0 && products.length > 0 && !isEmpty(memberItemCouponMap)) {
            selectItemCouponMap = calBestItemCoupon({
                coupons: memberItemCouponMap,
                products: products,
                selectItemCouponIds: calSelectItemCouponIds,
                timeZone: this.timeZone,
                notOrderBy: selectItemCouponIds.length > 0,
                selectItemCouponMap,
                alearedJoinFullItemPks,
                couponsConfigMap: couponsConfigMap,
            });
            each(selectItemCouponMap, (pk) => {
                notJoinFullItemPks.push(pk);
            });
        }
        const calProductResult = calProduct(this, products, Object.assign(Object.assign({}, opt), { isOrder: true, usePromoCodeStatus,
            alearedJoinFullItemPks }));
        if (!isEmpty(memberItemCouponMap)) {
            each(memberItemCouponMap, (coupon) => {
                if (coupon) {
                    coupon.pks = [];
                    const notUsePks = [];
                    if (coupon.canUse && coupon.status === StatusEnum.Enable) {
                        const canUseProductPk = [];
                        const couponProductMap = {};
                        each(products, (product) => {
                            if (product.pk) {
                                if (coupon.discountType === DiscountTypeEnum.SpecialOffer) {
                                    if (coupon.discountValue >= product.price || 0) {
                                        notUsePks.push(product.pk);
                                        coupon.status = StatusEnum.Disable;
                                        coupon.isSelect = false;
                                        return;
                                    }
                                }
                                couponProductMap[product.pk] = product;
                                if (((opt === null || opt === void 0 ? void 0 : opt.itemPlan) && opt.itemPlan[product.pk]) || alearedJoinFullItemPks.includes(product.pk)) {
                                    return;
                                }
                            }
                            if (coupon.canUse) {
                                if (coupon.discountType === DiscountTypeEnum.DiscountRate &&
                                    toFixed((coupon.isIncludeModifier ? product.productAndModifierPrice || 0 : product.price) *
                                        (1 - coupon.discountValue)) <= 0) {
                                    coupon.status = StatusEnum.Disable;
                                    coupon.isSelect = false;
                                    return;
                                }
                                if (!product.isFullItemNFree &&
                                    product.productAndModifierPrice > 0 &&
                                    findActivityProduct(couponsConfigMap[coupon.couponId].productMap, product)) {
                                    const id = product.pk || product.productNo + '_' + product.scaleNo;
                                    if (!alearedJoinFullItemPks.includes(id)) {
                                        const cnt = (product === null || product === void 0 ? void 0 : product.cnt) || 1;
                                        for (let i = 0; i < cnt; i++) {
                                            canUseProductPk.push(id);
                                        }
                                    }
                                }
                            }
                        });
                        coupon.canUseProductPk = cloneDeep(canUseProductPk);
                        coupon.notUsePks = cloneDeep(notUsePks);
                        if (canUseProductPk && canUseProductPk.length > 0) {
                            coupon.status = StatusEnum.Enable;
                            if (selectItemCouponMap[coupon.memberCouponId]) {
                                coupon.useItem = couponProductMap[selectItemCouponMap[coupon.memberCouponId]];
                            }
                            else {
                                const selectItemPks = values(selectItemCouponMap);
                                differenceSet(canUseProductPk, selectItemPks);
                                if (notUsePks.length > 0) {
                                    differenceSet(canUseProductPk, notUsePks);
                                }
                                if (canUseProductPk.length <= 0) {
                                    coupon.status = StatusEnum.Mutex;
                                }
                                else {
                                    coupon.pks = canUseProductPk;
                                }
                            }
                        }
                        else {
                            coupon.status = StatusEnum.Disable;
                            coupon.isSelect = false;
                        }
                    }
                    else {
                        coupon.status = StatusEnum.Disable;
                        coupon.isSelect = false;
                    }
                    if (coupon.status !== StatusEnum.Enable) {
                        delete selectItemCouponMap[coupon.memberCouponId];
                    }
                }
            });
        }
        let productAllOff = 0;
        addTimes = [dayjs().format(DEFAULT_FORMAT)];
        if ([CalTimeTypeEnum.OrderTime, CalTimeTypeEnum.OrderTimeIncludeStartTime].includes((_f = this.config) === null || _f === void 0 ? void 0 : _f.discountCalTime)) {
            addTimes = [(opt === null || opt === void 0 ? void 0 : opt.addTime) || dayjs().format(DEFAULT_FORMAT)];
        }
        opt = Object.assign(Object.assign({}, opt), { addTimes });
        const orderActivies = getEnableActivityByType(this, 
        // 自动整单活动
        [ActivityTypeEnum.OrderDiscount], opt);
        const nthItemNDiscountActivitys = getEnableActivityByType(this, [ActivityTypeEnum.NthItemNDiscount], opt); // 第N个N折
        const fullItemNFreeActivitys = getEnableActivityByType(this, [ActivityTypeEnum.FullItemNFree], opt); // 满N个,免费N个
        const designatedItemDiscountActivitys = getEnableActivityByType(this, [ActivityTypeEnum.DesignatedItemDiscount], opt); // 指定商品满减
        const ladderDiscountActivitys = getEnableActivityByType(this, [ActivityTypeEnum.LadderDiscount], opt); // 阶梯满减
        let orderPrice = 0; // 订单总金额
        const genOpt = {};
        let theSameItems = [];
        const designatedItems = [];
        const ladderItems = [];
        const boxMap = {};
        each(products, (product) => {
            var _a;
            if (product.type !== ProductTypeEnum.Express) {
                const id = product.pk || product.productNo + '_' + product.scaleNo;
                if (product.boxPrice && product.boxPrice > 0) {
                    boxMap[id] = Object.assign(Object.assign({}, product), { categoryNo: 'box', productNo: 'box', scaleNo: 'box', modifierPrice: 0, price: product.boxPrice, productAndModifierPrice: product.boxPrice, cnt: product.cnt, off: 0, pk: id + '_box' });
                }
                productMap[id] = product;
                orderPrice = toFixed(product.productAndModifierPrice * (product.cnt || 1) + orderPrice);
                if (product.fullItemNFreeProducts) {
                    each(product.fullItemNFreeProducts, (fullItemNFreeProduct) => {
                        orderPrice = toFixed((fullItemNFreeProduct.price + fullItemNFreeProduct.modifierPrice) * (fullItemNFreeProduct.cnt || 1) +
                            orderPrice);
                    });
                }
                const calProduct = calProductResult.itemMap[id] || Object.assign(Object.assign({}, product), { off: 0, offTip: '', offId: 0, offType: '' });
                if (calProduct) {
                    let couponCnt = 0;
                    if (calProduct.offType !== OffTypeEnum.Plan) {
                        if (!isEmpty(selectItemCouponMap)) {
                            each(selectItemCouponMap, (pk, memberCouponId) => {
                                const memberItemCoupon = memberItemCouponMap[memberCouponId];
                                if (pk === product.pk && memberItemCoupon) {
                                    if (itemMap[id]) {
                                        itemMap[id].items = filter(itemMap[id].items, { offType: OffTypeEnum.Coupon });
                                        itemMap[id].itemAllOff = sumBy(itemMap[id].items, 'off');
                                    }
                                    else {
                                        itemMap[id] = {
                                            items: [],
                                            itemAllOff: 0,
                                        };
                                    }
                                    let itemCouponDiscountFee = 0;
                                    let productPrice = product.price;
                                    if (memberItemCoupon.isIncludeModifier) {
                                        productPrice = product.productAndModifierPrice;
                                    }
                                    if (memberItemCoupon.discountType === DiscountTypeEnum.DiscountFee) {
                                        itemCouponDiscountFee = memberItemCoupon.discountValue;
                                    }
                                    else if (memberItemCoupon.discountType === DiscountTypeEnum.DiscountRate) {
                                        itemCouponDiscountFee = toFixed(productPrice * (1 - memberItemCoupon.discountValue));
                                    }
                                    else if (memberItemCoupon.discountType === DiscountTypeEnum.SpecialOffer) {
                                        itemCouponDiscountFee = productPrice - memberItemCoupon.discountValue;
                                    }
                                    if (itemCouponDiscountFee < 0) {
                                        itemCouponDiscountFee = 0;
                                    }
                                    else if (itemCouponDiscountFee > productPrice) {
                                        itemCouponDiscountFee = productPrice;
                                    }
                                    if ((opt === null || opt === void 0 ? void 0 : opt.isSelectCoupon) || itemCouponDiscountFee > calProduct.off / (calProduct.cnt || 1)) {
                                        memberItemCouponMap[memberCouponId].isSelect = true;
                                        itemCouponDiscountFee = toFixed(itemCouponDiscountFee);
                                        itemMap[id].items.push(Object.assign(Object.assign({}, calProduct), { off: itemCouponDiscountFee, offId: memberItemCoupon.memberCouponId, offTip: memberItemCoupon.couponName, offType: OffTypeEnum.Coupon, cnt: 1, isIncludeModifier: memberItemCoupon.isIncludeModifier || false }));
                                        itemMap[id].itemAllOff += itemCouponDiscountFee || 0;
                                        couponCnt++;
                                    }
                                    else {
                                        // memberItemCouponMap[memberCouponId].status = StatusEnum.Disable;
                                        memberItemCouponMap[memberCouponId].isSelect = false;
                                        memberItemCouponMap[memberCouponId].useItem = null;
                                        delete selectItemCouponMap[memberCouponId];
                                        const selectItemPks = values(selectItemCouponMap);
                                        each(memberItemCouponMap, (coupon) => {
                                            if (coupon.memberCouponId !== memberCouponId && coupon.status === StatusEnum.Mutex) {
                                                const canUseProductPk = memberItemCouponMap[memberCouponId].canUseProductPk || [];
                                                const notUsePks = memberItemCouponMap[memberCouponId].notUsePks || [];
                                                differenceSet(canUseProductPk, selectItemPks);
                                                if (notUsePks.length > 0) {
                                                    differenceSet(canUseProductPk, notUsePks);
                                                }
                                                if (canUseProductPk.length > 0) {
                                                    coupon.status = StatusEnum.Enable;
                                                    coupon.pks = canUseProductPk;
                                                }
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    }
                    if (((calProduct === null || calProduct === void 0 ? void 0 : calProduct.cnt) || 0) >= couponCnt) {
                        const productOff = toFixed(((calProduct === null || calProduct === void 0 ? void 0 : calProduct.off) / ((calProduct === null || calProduct === void 0 ? void 0 : calProduct.cnt) || 1)) * ((calProduct.cnt || 1) - couponCnt));
                        if (itemMap[id]) {
                            itemMap[id].items = filter(itemMap[id].items, (item) => item.isFullItemNFree || item.offType === OffTypeEnum.Coupon);
                            if (productOff > 0) {
                                itemMap[id].items.push(Object.assign(Object.assign({}, calProduct), { off: productOff, cnt: (calProduct.cnt || 1) - couponCnt }));
                            }
                            itemMap[id].itemAllOff = sumBy(itemMap[id].items, 'off');
                        }
                        else {
                            if (productOff > 0) {
                                itemMap[id] = {
                                    items: [Object.assign(Object.assign({}, calProduct), { off: productOff, cnt: (calProduct.cnt || 1) - couponCnt })],
                                    itemAllOff: productOff,
                                };
                            }
                        }
                    }
                    productAllOff += ((_a = itemMap[id]) === null || _a === void 0 ? void 0 : _a.itemAllOff) || 0;
                    const nowCnt = (calProduct.cnt || 1) - couponCnt;
                    if ((nthItemNDiscountActivitys.length > 0 || fullItemNFreeActivitys.length > 0) &&
                        calProduct.offType !== OffTypeEnum.Plan &&
                        !COMBOS.includes(calProduct.type)) {
                        if (nowCnt > 0) {
                            theSameItems.push(Object.assign(Object.assign({}, calProduct), { cnt: nowCnt }));
                        }
                    }
                    if (calProduct.offType !== OffTypeEnum.Plan) {
                        if ((designatedItemDiscountActivitys.length > 0 || designateCoupons.length > 0) &&
                            (calProduct.isOverlyDesignatedItemDiscount || !has(calProduct, 'isOverlyDesignatedItemDiscount'))) {
                            designatedItems.push(Object.assign({}, calProduct));
                        }
                        if ((ladderDiscountActivitys.length > 0 || ladderCoupons.length > 0) && !COMBOS.includes(calProduct.type)) {
                            ladderItems.push(Object.assign({}, calProduct));
                        }
                    }
                }
            }
        });
        if (calSingleItemSwapBuyRes === null || calSingleItemSwapBuyRes === void 0 ? void 0 : calSingleItemSwapBuyRes.remainingPayment) {
            orderPrice = toFixed(orderPrice + calSingleItemSwapBuyRes.remainingPayment);
        }
        usePromoCodeStatus = calProductResult.usePromoCodeStatus;
        const theSameItemMap = {};
        if (theSameItems.length > 0) {
            theSameItems = orderBy(theSameItems, ['modifierPrice', 'price'], ['desc', 'desc']);
            each(theSameItems, (item) => {
                const itemId = item.productNo + '_' + item.scaleNo;
                if (theSameItemMap[itemId]) {
                    theSameItemMap[itemId].push(Object.assign({}, item));
                }
                else {
                    theSameItemMap[itemId] = [Object.assign({}, item)];
                }
            });
        }
        const fullItemNFreeMap = {};
        /**
         * 计算满N免N
         */
        const calFullItemNFreeResult = calFullItemNFree2({
            theSameItemMap,
            itemMap,
            fullItemNFreeActivitys,
            enablePromoCodeActivity,
            usePromoCodeStatus,
            fullItemNFreeMap,
            productAllOff,
            alearedJoinFullItemPks,
            notJoinFullItemPks,
        });
        productAllOff = calFullItemNFreeResult.productAllOff;
        usePromoCodeStatus = calFullItemNFreeResult.usePromoCodeStatus;
        /**
         * 计算第N件N折
         */
        const calNthItemResult = calNthItemNDiscount({
            theSameItemMap,
            itemMap,
            nthItemNDiscountActivitys,
            enablePromoCodeActivity,
            usePromoCodeStatus,
        });
        productAllOff = calNthItemResult.productAllOff;
        usePromoCodeStatus = calNthItemResult.usePromoCodeStatus;
        const offArr = [];
        const calLadderResult = calLadderDiscount({
            ladderItems,
            ladderDiscountActivitys: cloneDeep(ladderDiscountActivitys),
            itemMap,
            productAllOff,
            usePromoCodeStatus,
            enablePromoCodeActivity,
            isSelectLadderCoupon,
            joinLadderCoupons,
            memberCouponMap,
            selectCouponIds: (opt === null || opt === void 0 ? void 0 : opt.selectCouponIds) || [],
            ladderCoupons,
            // joinLadderCouponIds,
            memberItemCouponMap,
            isSelectItemCoupon: isSelectItemCoupon,
            isSelectCoupon: opt.isSelectCoupon || false,
            couponsConfigMap,
            fullItemNFreeMap,
        });
        const genSelectCouponIds = new Set([]);
        let calDesignatedItemResult;
        if (calLadderResult.ladderDiscountAllOff > 0) {
            productAllOff = calLadderResult.productAllOff;
            usePromoCodeStatus = calLadderResult.usePromoCodeStatus;
            orderPrice = toFixed(orderPrice - productAllOff - calLadderResult.ladderDiscountAllOff);
        }
        else {
            let scenes = InteractiveScenes.MENU_LIST;
            if (this.eatType === EatTypeEnum.Mall) {
                scenes = InteractiveScenes.MALL_MENU_LIST;
            }
            /**
             * 指定商品满减
             */
            calDesignatedItemResult = calDesignatedItem({
                designatedItems,
                itemMap,
                designatedItemDiscountActivitys,
                productAllOff,
                productMap,
                enablePromoCodeActivity,
                usePromoCodeStatus,
                memberCouponMap,
                genSelectCouponIds,
                memberItemCouponMap,
                joinDesignateCoupons,
                designateCoupons,
                isSelectCoupon: opt.isSelectCoupon || false,
                selectCouponIds: opt.selectCouponIds || [],
                eatType: this.eatType,
                couponsConfigMap,
                menuPoducts: (_g = this.inputDatas[scenes]) === null || _g === void 0 ? void 0 : _g.products,
                fullItemNFreeMap,
                todayUsedCntMap,
            });
            if (calDesignatedItemResult.designatedItemAllOff > 0) {
                productAllOff = calDesignatedItemResult.productAllOff;
                usePromoCodeStatus = calDesignatedItemResult.usePromoCodeStatus;
                if (((_h = calDesignatedItemResult === null || calDesignatedItemResult === void 0 ? void 0 : calDesignatedItemResult.enablePromoCodeActivity) === null || _h === void 0 ? void 0 : _h.length) > 0) {
                    each(calDesignatedItemResult === null || calDesignatedItemResult === void 0 ? void 0 : calDesignatedItemResult.enablePromoCodeActivity, (enablePromoCodeActivityId) => {
                        if (!enablePromoCodeActivity.includes(enablePromoCodeActivityId)) {
                            enablePromoCodeActivity.push(enablePromoCodeActivityId);
                        }
                    });
                }
                each(calDesignatedItemResult.offArr, (off) => {
                    // 指定满减
                    upsertItemApportion({
                        products: off.products,
                        itemMap,
                        orderPrice: off.orderPrice,
                        allOff: off.off,
                        offId: off.offId,
                        offTip: off.offTip,
                        offType: off.offType,
                    });
                    offArr.push(off);
                });
                orderPrice = toFixed(orderPrice - calDesignatedItemResult.designatedItemAllOff - productAllOff);
            }
            else {
                orderPrice = toFixed(orderPrice - productAllOff);
                if (!isSelectDesignateCoupon && designateCoupons.length > 0) {
                    each(designateCoupons, (designateCoupon) => {
                        if (designateCoupon.canUse && designateCoupon.status === StatusEnum.Enable) {
                            if (designateCoupon.orderFee > designateCoupon.memberCardOff + orderPrice) {
                                designateCoupon.status = StatusEnum.Disable;
                                designateCoupon.canUse = false;
                                designateCoupon.isSelect = false;
                            }
                            else if (designateCoupon.orderFee > orderPrice) {
                                designateCoupon.status = StatusEnum.Mutex;
                            }
                        }
                    });
                }
            }
        }
        let orderOff = 0; // 订单优惠金额
        let orderOffName = '';
        let orderOffId = 0;
        let orderOffType = OffTypeEnum.Activity;
        let orderCoupon;
        const cashCouponMap = {}; // 选中的现金优惠券
        // 用户优惠券
        if (memberCouponMap && !isEmpty(memberCouponMap)) {
            let hasNotOverlying = false;
            let hasCashCoupon = false;
            if (opt === null || opt === void 0 ? void 0 : opt.selectCouponIds) {
                each(reverse(opt.selectCouponIds), (memberCouponId) => {
                    var _a;
                    const coupon = memberCouponMap[memberCouponId];
                    if (coupon) {
                        if (coupon.type === CouponTypeEnum.Order) {
                            if (coupon.canUse) {
                                orderCoupon = coupon;
                            }
                            else {
                                coupon.status = StatusEnum.Disable;
                                coupon.isSelect = false;
                            }
                        }
                        else if (coupon.type === CouponTypeEnum.Cash) {
                            if (coupon.canUse) {
                                if (!coupon.isOverlying) {
                                    if (!hasCashCoupon && !hasNotOverlying) {
                                        cashCouponMap[coupon.memberCouponId] = coupon;
                                    }
                                    hasNotOverlying = true;
                                }
                                else {
                                    cashCouponMap[coupon.memberCouponId] = coupon;
                                }
                                hasCashCoupon = true;
                            }
                            else {
                                coupon.status = StatusEnum.Disable;
                                coupon.isSelect = false;
                            }
                        }
                        else if (coupon.type === CouponTypeEnum.Designate) {
                            if (calLadderResult.ladderDiscountAllOff > 0) {
                                coupon.status = StatusEnum.Disable;
                                coupon.isSelect = false;
                                coupon.canUse = false;
                            }
                        }
                        else if (coupon.type === CouponTypeEnum.Ladder) {
                            if (!((_a = calLadderResult === null || calLadderResult === void 0 ? void 0 : calLadderResult.effectLadderCouponIds) === null || _a === void 0 ? void 0 : _a.includes(coupon.memberCouponId))) {
                                coupon.isSelect = false;
                            }
                        }
                        else if (coupon.type === CouponTypeEnum.Express) {
                            if (this.channel !== ChannelEnum.SelfDelivery && this.eatType !== EatTypeEnum.Mall) {
                                coupon.canUse = false;
                                coupon.status = StatusEnum.Disable;
                            }
                        }
                        else {
                            // 其他优惠券过滤
                            delete memberCouponMap[coupon.memberCouponId];
                        }
                    }
                });
            }
            const notLimitCachCoupons = [];
            each(memberCouponMap, (coupon) => {
                var _a, _b, _c;
                let status = StatusEnum.Enable;
                let isSelect = false;
                if (coupon.canUse) {
                    if (coupon.type === CouponTypeEnum.Cash) {
                        if (orderPrice <= 0) {
                            isSelect = false;
                            status = StatusEnum.Disable;
                            // 不能叠加使用
                        }
                        else if (hasCashCoupon && (!coupon.isOverlying || hasNotOverlying)) {
                            isSelect = false;
                            status = StatusEnum.Mutex;
                        }
                        if (status === StatusEnum.Enable) {
                            hasCashCoupon = true;
                            if (coupon.useLimitType === UseLimitTypeEnum.NoLimit) {
                                notLimitCachCoupons.push(coupon);
                            }
                            else {
                                if (coupon.isMockRecharge) {
                                    mockCashCoupons.push(coupon);
                                }
                                else {
                                    cashCoupons.push(coupon);
                                }
                            }
                        }
                    }
                    else if (coupon.type === CouponTypeEnum.Designate) {
                        if (calLadderResult.ladderDiscountAllOff > 0 ||
                            ((calDesignatedItemResult === null || calDesignatedItemResult === void 0 ? void 0 : calDesignatedItemResult.disableCouponIds.includes(coupon.couponId)) &&
                                !genSelectCouponIds.has(coupon.memberCouponId)) ||
                            (joinDesignateCoupons.length <= 0 && !(opt === null || opt === void 0 ? void 0 : opt.isSelectCoupon))) {
                            status = StatusEnum.Disable;
                            isSelect = false;
                            coupon.canUse = false;
                        }
                        else {
                            status = (_a = coupon.status) !== null && _a !== void 0 ? _a : StatusEnum.Disable;
                            isSelect = (_b = coupon.isSelect) !== null && _b !== void 0 ? _b : false;
                        }
                    }
                    else if (coupon.type === CouponTypeEnum.Ladder) {
                        if (((_c = calLadderResult === null || calLadderResult === void 0 ? void 0 : calLadderResult.effectLadderCouponIds) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                            if (calLadderResult.effectLadderCouponIds.includes(coupon.memberCouponId)) {
                                isSelect = true;
                                status = StatusEnum.Enable;
                            }
                        }
                    }
                    else if (coupon.type === CouponTypeEnum.Express) {
                        if (coupon.business !== BusinessEnum.Mall && this.channel !== ChannelEnum.SelfDelivery) {
                            isSelect = false;
                            status = StatusEnum.Disable;
                            coupon.canUse = false;
                        }
                    }
                    else {
                        isSelect = false;
                        status = StatusEnum.Disable;
                    }
                }
                else {
                    status = StatusEnum.Disable;
                    isSelect = false;
                }
                if (!isSelect && coupon.type === CouponTypeEnum.Order) {
                    if ((orderCoupon === null || orderCoupon === void 0 ? void 0 : orderCoupon.memberCouponId) === coupon.memberCouponId) {
                        orderCoupon = null;
                    }
                }
                memberCouponMap[coupon.memberCouponId].status = status;
                memberCouponMap[coupon.memberCouponId].isSelect = isSelect;
            });
            if (notLimitCachCoupons.length > 0) {
                cashCoupons.unshift(...notLimitCachCoupons);
            }
        }
        if (orderCoupon) {
            if (orderCoupon.discountType === DiscountTypeEnum.DiscountFee) {
                const complex = floor(orderPrice / (orderCoupon.orderFee || 0.1), 0);
                // orderOff = orderCoupon.discountValue * complex;
                if (complex >= 1) {
                    orderOff = orderCoupon.discountValue;
                }
            }
            else if (orderCoupon.discountType === DiscountTypeEnum.DiscountRate) {
                orderOff = toFixed(orderPrice * (1 - orderCoupon.discountValue));
            }
            if (orderOff) {
                orderOffId = orderCoupon.memberCouponId;
                orderOffName = orderCoupon.couponName;
                orderOffType = OffTypeEnum.Coupon;
                genSelectCouponIds.add(toInteger(orderCoupon.memberCouponId));
                memberCouponMap[orderCoupon.memberCouponId].isSelect = true;
            }
            else {
                if (memberCouponMap && !isEmpty(memberCouponMap)) {
                    memberCouponMap[orderCoupon.memberCouponId].isSelect = false;
                    memberCouponMap[orderCoupon.memberCouponId].status = StatusEnum.Disable;
                }
                orderCoupon = null;
            }
        }
        else {
            // 存在整单优惠活动
            let orderActivity;
            each(orderActivies, (activity) => {
                // 餐品里面有包含餐品就不参加这个活动
                let hasExcluded = false;
                if (activity.productRelation === ProductRelationEnum.Excluded) {
                    each(products, (product) => {
                        const findProduct = findActivityProduct(activity.productMap, product);
                        if (findProduct) {
                            hasExcluded = true;
                        }
                    });
                }
                if (!hasExcluded && activity.orderFee <= orderPrice) {
                    let activityOff = 0;
                    if (activity.discountType === DiscountTypeEnum.DiscountFee) {
                        const complex = floor(orderPrice / activity.orderFee, 0);
                        activityOff = toFixed(activity.discountValue * complex);
                    }
                    else if (activity.discountType === DiscountTypeEnum.DiscountRate) {
                        activityOff = toFixed(orderPrice * (1 - activity.discountValue));
                    }
                    if (activity.maxDiscountFee && activityOff > activity.maxDiscountFee) {
                        activityOff = activity.maxDiscountFee;
                    }
                    if (activityOff > orderOff) {
                        // 取最低优惠
                        orderOff = activityOff;
                        orderOffName = activity.activityName;
                        orderOffId = activity.activityId;
                        orderOffType = OffTypeEnum.Activity;
                        orderActivity = activity;
                    }
                }
            });
            if (orderActivity && orderActivity.promoCode) {
                usePromoCodeStatus = UsePromoCodeStatusEnum.Effective;
                orderOffType = OffTypeEnum.PromoCode;
                if (!enablePromoCodeActivity.includes(orderActivity.activityId)) {
                    enablePromoCodeActivity.push(orderActivity.activityId);
                }
            }
        }
        if (orderPrice < orderOff) {
            orderOff = orderPrice;
        }
        if (orderOffId && orderOff > 0) {
            const offObj = {
                off: orderOff,
                offTip: orderOffName || '',
                offId: orderOffId,
                offType: orderOffType,
            };
            // Object.freeze(offObj);
            offArr.push(offObj);
            // 自动活动分摊
            upsertItemApportion({
                products,
                itemMap,
                orderPrice,
                allOff: orderOff,
                offId: orderOffId,
                offTip: orderOffName || '',
                offType: orderOffType,
            });
            orderPrice = toFixed(orderPrice - orderOff);
        }
        let calOrderSwapBuyRes = {};
        const reductionOrderSwapMap = {};
        // 整单换购
        if ((opt === null || opt === void 0 ? void 0 : opt.orderSwapBuyProducts) &&
            opt.orderSwapBuyProducts.length > 0 &&
            opt.orderSwapBuyProducts[0].detailId &&
            opt.orderSwapBuyProducts[0].orderDisocuntList) {
            each(opt === null || opt === void 0 ? void 0 : opt.orderSwapBuyProducts, (orderSwapBuyProduct) => {
                each(orderSwapBuyProduct.orderDisocuntList, (orderDisocunt) => {
                    const id = orderSwapBuyProduct.pk || orderSwapBuyProduct.productNo + '_' + orderSwapBuyProduct.scaleNo;
                    if (!reductionOrderSwapMap[id]) {
                        if (!itemMap[id]) {
                            itemMap[id] = {
                                items: [],
                                itemAllOff: 0,
                            };
                        }
                        itemMap[id].items.push(Object.assign(Object.assign({}, orderSwapBuyProduct), { off: orderDisocunt.fee, offId: orderDisocunt.activityId, offTip: orderDisocunt.discountName, offType: OffTypeEnum.Activity, isIncludeModifier: false }));
                        itemMap[id].itemAllOff += orderDisocunt.fee;
                        reductionOrderSwapMap[id] = true;
                    }
                });
            });
        }
        else {
            const orderSwapBuyActivitys = getEnableActivityByType(this, [ActivityTypeEnum.OrderSwapBuy], opt);
            calOrderSwapBuyRes = calOrderSwapBuy({
                orderPrice,
                products,
                itemMap,
                orderSwapBuyActivitys: cloneDeep(orderSwapBuyActivitys),
                usePromoCodeStatus,
                enablePromoCodeActivity,
                orderSwapBuyProducts: cloneDeep(opt.orderSwapBuyProducts || []),
            });
            usePromoCodeStatus = calOrderSwapBuyRes.usePromoCodeStatus;
            orderPrice = calOrderSwapBuyRes.orderPrice;
        }
        if (mockCashCoupons.length > 0) {
            cashCoupons.push(...mockCashCoupons);
        }
        // 没有订单优惠券且用户没有自己选择
        if (isEmpty(cashCouponMap) && !(opt === null || opt === void 0 ? void 0 : opt.isSelectCoupon) && cashCoupons.length > 0) {
            calBestCashCoupon({ coupons: cashCoupons, orderPrice, cashCouponMap });
        }
        if (!isEmpty(cashCouponMap)) {
            each(cashCouponMap, (coupon) => {
                if (orderPrice > 0 &&
                    ((coupon === null || coupon === void 0 ? void 0 : coupon.useLimitType) === UseLimitTypeEnum.NoLimit ||
                        todayUsedCntMap.get(coupon.couponId) < (coupon.useLimitCnt || 0))) {
                    let cashCouponOff = coupon.discountValue;
                    if (orderPrice < coupon.discountValue) {
                        cashCouponOff = orderPrice;
                    }
                    memberCouponMap[coupon.memberCouponId].isSelect = coupon.isSelect = true;
                    offArr.push({
                        off: cashCouponOff,
                        offTip: coupon.couponName,
                        offId: coupon.memberCouponId,
                        offType: OffTypeEnum.Coupon,
                    });
                    genSelectCouponIds.add(toInteger(coupon.memberCouponId));
                    upsertItemApportion({
                        products: [...products, ...calSingleItemSwapBuyRes === null || calSingleItemSwapBuyRes === void 0 ? void 0 : calSingleItemSwapBuyRes.allSwapBuyProducts],
                        itemMap,
                        orderPrice,
                        allOff: cashCouponOff,
                        offTip: coupon.couponName,
                        offId: coupon.memberCouponId,
                        offType: OffTypeEnum.Coupon,
                        discountType: coupon.discountType,
                    });
                    orderPrice = toFixed(orderPrice - cashCouponOff);
                    if (memberCouponMap && !isEmpty(memberCouponMap)) {
                        memberCouponMap[coupon.memberCouponId].isSelect = true;
                        memberCouponMap[coupon.memberCouponId].status = StatusEnum.Enable;
                    }
                    todayUsedCntMap.increase(coupon.couponId);
                }
                else {
                    if (memberCouponMap && !isEmpty(memberCouponMap)) {
                        memberCouponMap[coupon.memberCouponId].isSelect = false;
                        memberCouponMap[coupon.memberCouponId].status = StatusEnum.Disable;
                    }
                }
            });
            if (orderPrice <= 0) {
                each(memberCouponMap, (coupon) => {
                    if (coupon.type === CouponTypeEnum.Cash && !coupon.isSelect && coupon.status === StatusEnum.Enable) {
                        coupon.status = StatusEnum.Mutex;
                    }
                });
            }
        }
        let integral;
        // 允许积分低现
        if (((_j = this === null || this === void 0 ? void 0 : this.optMemberCard) === null || _j === void 0 ? void 0 : _j.isIntegralMoney) && !((_k = this === null || this === void 0 ? void 0 : this.optMemberCard) === null || _k === void 0 ? void 0 : _k.isExpired)) {
            // 积分抵现字段
            let useIntegral = 0; // 使用多少积分
            let integralDiscountMoney = 0; // 抵多少钱
            if (this.optMemberCard.integralMoney / ((_l = this.optMemberCard) === null || _l === void 0 ? void 0 : _l.integralCostMoney) && (this === null || this === void 0 ? void 0 : this.optMemberCard.integral)) {
                integralDiscountMoney = floor((((_m = this.optMemberCard) === null || _m === void 0 ? void 0 : _m.integral) / this.optMemberCard.integralMoney) * ((_o = this.optMemberCard) === null || _o === void 0 ? void 0 : _o.integralCostMoney), 2);
            }
            let maxMoney = 0;
            if (((_p = this.optMemberCard) === null || _p === void 0 ? void 0 : _p.integralMoneyMaxType) === DiscountTypeEnum.DiscountFee) {
                maxMoney = ((_q = this.optMemberCard) === null || _q === void 0 ? void 0 : _q.integralMoneyMax) || 0;
            }
            else if (((_r = this.optMemberCard) === null || _r === void 0 ? void 0 : _r.integralMoneyMaxType) === DiscountTypeEnum.DiscountRate) {
                maxMoney = orderPrice * (((_s = this.optMemberCard) === null || _s === void 0 ? void 0 : _s.integralMoneyMax) || 0);
            }
            if (maxMoney < integralDiscountMoney) {
                integralDiscountMoney = maxMoney;
            }
            if (integralDiscountMoney > orderPrice) {
                integralDiscountMoney = orderPrice;
            }
            integralDiscountMoney = floor(integralDiscountMoney, 2);
            if (integralDiscountMoney && integralDiscountMoney > 0) {
                useIntegral = floor((integralDiscountMoney / this.optMemberCard.integralCostMoney) * this.optMemberCard.integralMoney);
                const useIntegralRemainder = useIntegral % this.optMemberCard.integralMoney;
                if (useIntegralRemainder !== 0) {
                    useIntegral = useIntegral - useIntegralRemainder;
                    if (useIntegral < 0) {
                        useIntegral = 0;
                    }
                }
            }
            integralDiscountMoney =
                (useIntegral / this.optMemberCard.integralMoney) * (((_t = this.optMemberCard) === null || _t === void 0 ? void 0 : _t.integralCostMoney) || 1);
            if ((opt === null || opt === void 0 ? void 0 : opt.isUseIntegral) && integralDiscountMoney > 0) {
                upsertItemApportion({
                    products,
                    itemMap,
                    orderPrice,
                    allOff: integralDiscountMoney,
                    offTip: OffTypeEnum.IntegralMoney,
                    offId: ((_u = this.optMemberCard) === null || _u === void 0 ? void 0 : _u.memberCardId) || 0,
                    offType: OffTypeEnum.IntegralMoney,
                    discountType: DiscountTypeEnum.DiscountFee,
                });
                offArr.push({
                    off: integralDiscountMoney,
                    offTip: OffTypeEnum.IntegralMoney,
                    offId: ((_v = this.optMemberCard) === null || _v === void 0 ? void 0 : _v.memberCardId) || 0,
                    offType: OffTypeEnum.IntegralMoney,
                });
                orderPrice = toFixed(orderPrice - integralDiscountMoney);
            }
            const optMemberCard = this.optMemberCard || {};
            integral = {
                useIntegral,
                integralDiscountMoney,
                memberCardIntegral: optMemberCard.integral || 0,
                integralMoneyMax: optMemberCard.integralMoneyMax,
                integralMoneyMaxType: optMemberCard.integralMoneyMaxType,
                integralNumber: optMemberCard.integralMoney,
                integralCostMoney: optMemberCard.integralCostMoney, // 抵多少钱
            };
            // 加密积分使用情况
            genOpt.integral = {
                useIntegral,
                integralDiscountMoney,
                discountType: optMemberCard.integralMoneyMaxType,
            };
        }
        if (expressProducts.length > 0) {
            /**
             * 计算配送减免活动
             */
            const calExpressFeeDiscountResp = calExpressFeeDiscount({
                itemMap,
                productMap,
                expressFeeDiscountcountActivitys: getEnableActivityByType(this, [ActivityTypeEnum.ExpressFeeDiscount], opt),
                expressCoupons: expressCoupons,
                expressProducts,
                isSelectCoupon: (opt === null || opt === void 0 ? void 0 : opt.isSelectCoupon) || false,
                selectCouponIds: (opt === null || opt === void 0 ? void 0 : opt.selectCouponIds) || [],
                memberCouponMap: memberCouponMap,
                couponsConfigMap,
                enablePromoCodeActivity,
                usePromoCodeStatus,
            });
            usePromoCodeStatus = calExpressFeeDiscountResp.usePromoCodeStatus;
        }
        let orderPlanOff = 0;
        const orderPlan = opt === null || opt === void 0 ? void 0 : opt.orderPlan;
        if (orderPlan) {
            if (!isEmpty(boxMap)) {
                each(boxMap, (box) => {
                    products.push(box);
                    orderPrice += box.price * (box.cnt || 1);
                });
            }
            if (boxProduct) {
                products.push(boxProduct);
                orderPrice += boxProduct.price;
            }
            if (orderPlan.discountType === DiscountTypeEnum.DiscountFee) {
                orderPlanOff = orderPlan.discountValue;
            }
            else if (orderPlan.discountType === DiscountTypeEnum.DiscountRate) {
                orderPlanOff = toFixed(orderPrice * (1 - orderPlan.discountValue));
            }
            if (orderPlanOff > 0) {
                if (orderPlanOff > orderPrice) {
                    orderPlanOff = orderPrice;
                }
                offArr.push({
                    off: orderPlanOff,
                    offTip: orderPlan.discountReason,
                    offId: orderPlan.tagId || 0,
                    offType: OffTypeEnum.Plan,
                });
                // 手动活动分摊
                upsertItemApportion({
                    products,
                    itemMap,
                    orderPrice,
                    allOff: orderPlanOff,
                    offTip: orderPlan.discountReason,
                    offId: orderPlan.tagId || 0,
                    offType: OffTypeEnum.Plan,
                    discountType: orderPlan.discountType,
                });
                orderPrice = toFixed(orderPrice - orderPlanOff);
            }
        }
        if (this.bo === BoEnum.CN && orderPrice > 0 && this.orderPlan && this.orderPlan.floor) {
            if (this.orderPlan.floor.floorPayType === FloorPayTypeEnum.All || // 所有方式抹零
                ((opt === null || opt === void 0 ? void 0 : opt.isCashPay) && this.orderPlan.floor.floorPayType === FloorPayTypeEnum.Cash) // 现金方式抹零
            ) {
                let floorFee = 0; // 抹零金额
                genOpt.floorType = this.orderPlan.floor.floorType;
                genOpt.floorPayType = this.orderPlan.floor.floorPayType;
                switch (this.orderPlan.floor.floorType) {
                    case FloorTypeEnum.FloorInt: // 抹零到元
                        floorFee = toFixed(orderPrice - floor(orderPrice));
                        break;
                    case FloorTypeEnum.FloorHalf: // 抹零5角
                        // 0.5 的倍数不用抹
                        if (!isInteger(orderPrice / 0.5)) {
                            const ceilPrice = ceil(orderPrice);
                            if (ceilPrice - 0.5 > orderPrice) {
                                floorFee = toFixed(orderPrice - floor(orderPrice));
                            }
                            else {
                                floorFee = toFixed(orderPrice - (ceilPrice - 0.5));
                            }
                        }
                        break;
                    case FloorTypeEnum.FloorTenth: // 抹零1角
                        floorFee = toFixed(orderPrice - floor(orderPrice, 1));
                        break;
                    default:
                        break;
                }
                if (floorFee > 0) {
                    upsertItemApportion({
                        products,
                        itemMap,
                        orderPrice,
                        allOff: floorFee,
                        offTip: '抹零',
                        offId: (_w = this.orderPlan) === null || _w === void 0 ? void 0 : _w.planId,
                        offType: OffTypeEnum.Floor,
                        discountType: DiscountTypeEnum.DiscountFee,
                    });
                    offArr.push({
                        off: floorFee,
                        offTip: '抹零',
                        offId: (_x = this.orderPlan) === null || _x === void 0 ? void 0 : _x.planId,
                        offType: OffTypeEnum.Floor,
                    });
                    orderPrice = toFixed(orderPrice - floorFee);
                }
            }
        }
        let groupBuyActivityId = null;
        let sumAllOff = 0;
        const mockRechargeCanUseCouponIds = [];
        const mockRechargeCanUseMemberCouponIds = [];
        each(itemMap, (items) => {
            var _a, _b, _c;
            remove(items.items, (item) => {
                var _a, _b;
                if (item.offType === OffTypeEnum.PromoCode) {
                    if (item.activity && !enablePromoCodeActivity.includes(item.activity.activityId)) {
                        enablePromoCodeActivity.push(item.activity.activityId);
                    }
                }
                else if (((_a = item.activity) === null || _a === void 0 ? void 0 : _a.type) === ActivityTypeEnum.GroupBuy) {
                    groupBuyActivityId = item.activity.activityId;
                }
                if (item.offType === OffTypeEnum.Coupon) {
                    genSelectCouponIds.add(toInteger(item.offId));
                    if (item.offId &&
                        cloneMemberCoupon &&
                        cloneMemberCoupon[item.offId] &&
                        ((_b = cloneMemberCoupon[item.offId]) === null || _b === void 0 ? void 0 : _b.isMockRecharge)) {
                        item.mockCouponId = cloneMemberCoupon[item.offId].couponId;
                        if (!mockRechargeCanUseMemberCouponIds.includes(cloneMemberCoupon[item.offId].memberCouponId)) {
                            mockRechargeCanUseMemberCouponIds.push(cloneMemberCoupon[item.offId].memberCouponId);
                        }
                        if (!mockRechargeCanUseCouponIds.includes(cloneMemberCoupon[item.offId].couponId)) {
                            mockRechargeCanUseCouponIds.push(cloneMemberCoupon[item.offId].couponId);
                        }
                    }
                }
                unset(item, 'activity');
                unset(item, 'key');
                unset(item, 'type');
                unset(item, 'detailId');
                return item.off <= 0;
            });
            if (((_a = items.apportion) === null || _a === void 0 ? void 0 : _a.offArr) && ((_c = (_b = items.apportion) === null || _b === void 0 ? void 0 : _b.offArr) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                each(items.apportion.offArr, (off) => {
                    var _a;
                    if (off.offId &&
                        cloneMemberCoupon &&
                        cloneMemberCoupon[off.offId] &&
                        ((_a = cloneMemberCoupon[off.offId]) === null || _a === void 0 ? void 0 : _a.isMockRecharge)) {
                        off.mockCouponId = cloneMemberCoupon[off.offId].couponId;
                        if (!mockRechargeCanUseMemberCouponIds.includes(cloneMemberCoupon[off.offId].memberCouponId)) {
                            mockRechargeCanUseMemberCouponIds.push(cloneMemberCoupon[off.offId].memberCouponId);
                        }
                        if (!mockRechargeCanUseCouponIds.includes(cloneMemberCoupon[off.offId].couponId)) {
                            mockRechargeCanUseCouponIds.push(cloneMemberCoupon[off.offId].couponId);
                        }
                    }
                });
            }
            sumAllOff += items.itemAllOff;
        });
        if (mockRechargeCanUseCouponIds.length > 0) {
            genOpt.mockUseCouponIds = mockRechargeCanUseCouponIds;
        }
        if (genSelectCouponIds && genSelectCouponIds.size > 0) {
            genOpt.selectCouponIds = [...genSelectCouponIds];
        }
        if (!isEmpty(this.config)) {
            genOpt.config = {
                couponExpireRemind: this.config.couponExpireRemind,
                discountCalTime: this.config.discountCalTime,
            };
        }
        if (!isEmpty(singleItemSwapBuyMap)) {
            each(singleItemSwapBuyMap, (singleItemSwapBuy) => {
                each(singleItemSwapBuy.validProducts, (validProduct) => {
                    const validPk = validProduct.pk || '';
                    if (!itemMap[validPk]) {
                        itemMap[validPk] = {
                            items: [validProduct],
                            itemAllOff: validProduct.off,
                            apportion: {
                                off: 0,
                                offArr: [],
                            },
                        };
                    }
                    else {
                        itemMap[validPk].items.push(validProduct);
                        itemMap[validPk].itemAllOff += validProduct.off;
                    }
                });
            });
        }
        genOpt.itemMap = itemMap;
        each(offArr, (offA) => {
            var _a;
            sumAllOff += offA.off;
            if (offA.offId &&
                cloneMemberCoupon &&
                cloneMemberCoupon[offA.offId] &&
                ((_a = cloneMemberCoupon[offA.offId]) === null || _a === void 0 ? void 0 : _a.isMockRecharge)) {
                offA.mockCouponId = cloneMemberCoupon[offA.offId].couponId;
                if (!mockRechargeCanUseMemberCouponIds.includes(cloneMemberCoupon[offA.offId].memberCouponId)) {
                    mockRechargeCanUseMemberCouponIds.push(cloneMemberCoupon[offA.offId].memberCouponId);
                }
                if (!mockRechargeCanUseCouponIds.includes(cloneMemberCoupon[offA.offId].couponId)) {
                    mockRechargeCanUseCouponIds.push(cloneMemberCoupon[offA.offId].couponId);
                }
            }
        });
        (orderPlan === null || orderPlan === void 0 ? void 0 : orderPlan.isLock) && (genOpt.isLockOrderPlan = orderPlan === null || orderPlan === void 0 ? void 0 : orderPlan.isLock);
        let result = {
            itemMap,
            offArr,
            groupBuyActivityId,
            sk: this.genSK(genOpt),
            memberCouponMap,
            memberItemCouponMap,
            usePromoCodeStatus,
            version: VERSION,
            memberCardId: (_y = this.optMemberCard) === null || _y === void 0 ? void 0 : _y.memberCardId,
            memberId: (_z = this.member) === null || _z === void 0 ? void 0 : _z.memberId,
            memberType: ((_0 = this.member) === null || _0 === void 0 ? void 0 : _0.type) || null,
            bo: this.bo,
            brandId: this.brandId,
            storeId: this.storeId,
            floorType: (_2 = (_1 = this === null || this === void 0 ? void 0 : this.orderPlan) === null || _1 === void 0 ? void 0 : _1.floor) === null || _2 === void 0 ? void 0 : _2.floorType,
            floorPayType: (_4 = (_3 = this === null || this === void 0 ? void 0 : this.orderPlan) === null || _3 === void 0 ? void 0 : _3.floor) === null || _4 === void 0 ? void 0 : _4.floorPayType,
            promoCodeActivity: this.getPromoCodeActivies((opt === null || opt === void 0 ? void 0 : opt.promoCodes) || [''], enablePromoCodeActivity) || [],
            singleItemSwapBuyMap,
            fullItemNFreeMap,
            sumAllOff,
            noPurchasedCardMap: {},
            isIntegralMoney: (!((_5 = this === null || this === void 0 ? void 0 : this.optMemberCard) === null || _5 === void 0 ? void 0 : _5.isExpired) && ((_6 = this.optMemberCard) === null || _6 === void 0 ? void 0 : _6.isIntegralMoney)) || false,
            orderSwapBuy: null,
        };
        if (calOrderSwapBuyRes === null || calOrderSwapBuyRes === void 0 ? void 0 : calOrderSwapBuyRes.orderSwapBuyActivity) {
            result.orderSwapBuy = {};
            result.orderSwapBuy.activity = calOrderSwapBuyRes.orderSwapBuyActivity; // 整单换购物活动
            if (result.orderSwapBuy.activity && isNull(result.orderSwapBuy.activity.products)) {
                result.orderSwapBuy.activity.products = [];
            }
        }
        if (calOrderSwapBuyRes === null || calOrderSwapBuyRes === void 0 ? void 0 : calOrderSwapBuyRes.joinOrderSwapBuyProductMap) {
            if (!result.orderSwapBuy) {
                result.orderSwapBuy = {};
            }
            result.orderSwapBuy.productMap = calOrderSwapBuyRes.joinOrderSwapBuyProductMap; // 参加整单换购的餐品数据
        }
        if (integral) {
            result.integral = integral;
        }
        result.getIntegral = this.getIntegral(orderPrice);
        let scenes = InteractiveScenes.ORDER_SETTLEMENT;
        if (this.eatType === EatTypeEnum.Mall) {
            scenes = InteractiveScenes.MALL_ORDER_SETTLEMENT;
        }
        // 计算更优惠的没有购买的付费会员卡
        if (this.appType === AppTypeEnum.Mobile &&
            !opt.isCalNoPurchasedCards &&
            ((_7 = this.member) === null || _7 === void 0 ? void 0 : _7.noPurchasedCards) &&
            ((_8 = this.member) === null || _8 === void 0 ? void 0 : _8.noPurchasedCards.length) > 0) {
            const groupBuyActivities = getEnableActivityByType(this, [ActivityTypeEnum.GroupBuy], {
                business: BusinessEnum.MemberCard,
            });
            const nowMember = cloneDeep(this.member);
            for (const noPurchasedCard of (_9 = this.member) === null || _9 === void 0 ? void 0 : _9.noPurchasedCards) {
                if (this.eatType !== EatTypeEnum.Mall &&
                    !noPurchasedCard.isAllStore &&
                    !((_10 = noPurchasedCard.storeIds) === null || _10 === void 0 ? void 0 : _10.includes(this.storeId))) {
                    continue;
                }
                else if (this.eatType === EatTypeEnum.Mall && !noPurchasedCard.mallDiscountType) {
                    continue;
                }
                this.member = cloneDeep(cloneMember);
                noPurchasedCard.memberCardId = noPurchasedCard.cardId;
                const groupBuyActivityProducts = calGroupBuyCard({ card: noPurchasedCard, activities: groupBuyActivities });
                this.optMemberCard = noPurchasedCard;
                if (this.eatType === EatTypeEnum.Mall) {
                    this.optMemberCard.productRelation = noPurchasedCard.mallProductRelation;
                    this.optMemberCard.discountType = noPurchasedCard.mallDiscountType || '';
                    this.optMemberCard.discountValue = noPurchasedCard.mallDiscountValue || 0;
                }
                const reCallResult = this.actualCalOrder(cloneDeep(this.inputDatas[scenes].products), Object.assign(Object.assign({}, cloneDeep(this.inputDatas[scenes].opt)), { isNeedNotice: false, isCalNoPurchasedCards: true, onlyBalancePay: false }));
                let thriftOff = toFixed(reCallResult.sumAllOff - sumAllOff);
                if (thriftOff > 0 || (groupBuyActivityProducts && groupBuyActivityProducts.length > 0)) {
                    if (thriftOff < 0) {
                        thriftOff = 0;
                    }
                    result.noPurchasedCardMap[noPurchasedCard.cardId] = {
                        cardId: noPurchasedCard.cardId,
                        thriftOff: thriftOff || 0,
                        activityProducts: groupBuyActivityProducts,
                    };
                }
            }
            this.member = nowMember;
            this.optMemberCard = originOptMemberCard;
        }
        if (calDesignatedItemResult === null || calDesignatedItemResult === void 0 ? void 0 : calDesignatedItemResult.designatedBuyAgain) {
            // 满减再买多少减多少
            result.designatedBuyAgain = calDesignatedItemResult.designatedBuyAgain;
        }
        // 优惠金额+卡的余额 小于付款的钱的时候
        if ((this === null || this === void 0 ? void 0 : this.optMemberCard) &&
            ((_12 = (_11 = this === null || this === void 0 ? void 0 : this.optMemberCard) === null || _11 === void 0 ? void 0 : _11.recharges) === null || _12 === void 0 ? void 0 : _12.length) > 0 &&
            sumAllOff > 0 &&
            sumAllOff + (((_13 = this === null || this === void 0 ? void 0 : this.optMemberCard) === null || _13 === void 0 ? void 0 : _13.balance) || 0) < originFee &&
            !isInteger(opt.mockCardRechargeId)) {
            // 钱不够的时候,需要用余额全额支付
            if (opt.onlyBalancePay) {
                let clearMemberCard = false;
                if (((_14 = this.optMemberCard.extra) === null || _14 === void 0 ? void 0 : _14.balanceDiscountRule) === BalanceDiscountRuleEnum.OnlyBalancePay) {
                    clearMemberCard = true;
                }
                const reCallOnlyBalancePayResult = this.actualCalOrder(cloneDeep(this.inputDatas[scenes].products), Object.assign(Object.assign({}, cloneDeep(this.inputDatas[scenes].opt)), { onlyBalancePay: false, isNeedNotice: false, clearMemberCard, isCalNoPurchasedCards: true }));
                const onlyBalancePayMoreOff = sumAllOff - reCallOnlyBalancePayResult.sumAllOff;
                if (onlyBalancePayMoreOff > result.sumAllOff) {
                    result = reCallOnlyBalancePayResult;
                    result.onlyBalancePayRechargeMoney = toFixed(originFee - sumAllOff - (((_15 = this === null || this === void 0 ? void 0 : this.optMemberCard) === null || _15 === void 0 ? void 0 : _15.balance) || 0));
                    result.onlyBalancePayMoreOff = onlyBalancePayMoreOff;
                }
                this.member = cloneMember;
                this.optMemberCard = originOptMemberCard;
            }
        }
        else {
            if (!opt.onlyBalancePay) {
                this.member = cloneMember;
                this.optMemberCard = originOptMemberCard;
            }
        }
        // 永远算使用了优惠券的情况
        if (opt.mockCardRechargeId && canMockCardRechargeSendCoupon) {
            // 在算一次不使用优惠券的情况
            const reCallMockCardRechargeResult = this.actualCalOrder(cloneDeep(this.inputDatas[scenes].products), Object.assign(Object.assign({}, cloneDeep(this.inputDatas[scenes].opt)), { isNeedNotice: false, mockCardRechargeId: 0, isCalNoPurchasedCards: true }));
            // 不使用优惠券
            if (!(opt === null || opt === void 0 ? void 0 : opt.mockCardRechargeUseCoupon)) {
                result = reCallMockCardRechargeResult;
            }
            if (sumAllOff > reCallMockCardRechargeResult.sumAllOff) {
                result.mockRechargeUseCouponMoreOff = toFixed(sumAllOff - reCallMockCardRechargeResult.sumAllOff);
            }
            else {
                result.mockRechargeUseCouponMoreOff = 0;
            }
            if (mockRechargeCanUseCouponIds.length > 0 && result.mockRechargeUseCouponMoreOff > 0) {
                result.mockRechargeCanUseCouponIds = mockRechargeCanUseCouponIds;
            }
            this.member = cloneMember;
            this.optMemberCard = originOptMemberCard;
        }
        else if (opt.mockCardRechargeId) {
            this.member = cloneMember;
            this.optMemberCard = originOptMemberCard;
        }
        // if (opt?.isNeedNotice && this.inited) {
        //   this.concessionListeners[scenes] && this.concessionListeners[scenes](null, result);
        // }
        return result;
    }
    /**
     * 订单计算
     * @param products
     */
    calOrder(products, opt) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        if (!this.canUseMmg) {
            return {
                itemMap: {},
                offArr: [],
                groupBuyActivityId: null,
                sk: null,
                memberCouponMap: {},
                memberItemCouponMap: {},
                usePromoCodeStatus: '',
                version: VERSION,
                memberCardId: (_a = this.optMemberCard) === null || _a === void 0 ? void 0 : _a.memberCardId,
                memberId: (_b = this.member) === null || _b === void 0 ? void 0 : _b.memberId,
                memberType: ((_c = this.member) === null || _c === void 0 ? void 0 : _c.type) || null,
                bo: this.bo,
                brandId: this.brandId,
                storeId: this.storeId,
                floorType: (_e = (_d = this === null || this === void 0 ? void 0 : this.orderPlan) === null || _d === void 0 ? void 0 : _d.floor) === null || _e === void 0 ? void 0 : _e.floorType,
                floorPayType: (_g = (_f = this === null || this === void 0 ? void 0 : this.orderPlan) === null || _f === void 0 ? void 0 : _f.floor) === null || _g === void 0 ? void 0 : _g.floorPayType,
                promoCodeActivity: [],
                singleItemSwapBuyMap: {},
                fullItemNFreeMap: {},
                sumAllOff: 0,
                noPurchasedCardMap: {},
                isIntegralMoney: false,
                orderSwapBuy: null,
                canUseMmg: (this === null || this === void 0 ? void 0 : this.canUseMmg) || false,
            };
        }
        let allPrice = 0;
        each(products, (product) => {
            // console.log('product为', product);
            // console.log('product.boxPrice为', product.boxPrice);
            // console.log('product.productAndModifierPrice为', product.productAndModifierPrice);
            // const productPrice = (product.boxPrice || 0) + (product.price + product.modifierPrice || 0) * (product.cnt || 0);
            // console.log('product的价格为', productPrice);
            allPrice += (product.boxPrice || 0) + (product.price + product.modifierPrice || 0) * (product.cnt || 0);
        });
        // console.log('总价为', allPrice);
        const balanceResult = this.balancePayCalOrder(products, opt);
        // console.log('全额支付的结果为', balanceResult);
        const noBalanceResult = this.noBalancePayCalOrder(products, opt);
        // console.log('非全额支付的结果为', noBalanceResult);
        let result = {
            itemMap: {},
            offArr: [],
            groupBuyActivityId: null,
            sk: null,
            memberCouponMap: {},
            memberItemCouponMap: {},
            usePromoCodeStatus: '',
            version: VERSION,
            memberCardId: (_h = this.optMemberCard) === null || _h === void 0 ? void 0 : _h.memberCardId,
            memberId: (_j = this.member) === null || _j === void 0 ? void 0 : _j.memberId,
            memberType: ((_k = this.member) === null || _k === void 0 ? void 0 : _k.type) || null,
            bo: this.bo,
            brandId: this.brandId,
            storeId: this.storeId,
            floorType: (_m = (_l = this === null || this === void 0 ? void 0 : this.orderPlan) === null || _l === void 0 ? void 0 : _l.floor) === null || _m === void 0 ? void 0 : _m.floorType,
            floorPayType: (_p = (_o = this === null || this === void 0 ? void 0 : this.orderPlan) === null || _o === void 0 ? void 0 : _o.floor) === null || _p === void 0 ? void 0 : _p.floorPayType,
            promoCodeActivity: [],
            singleItemSwapBuyMap: {},
            fullItemNFreeMap: {},
            sumAllOff: 0,
            noPurchasedCardMap: {},
            isIntegralMoney: false,
            orderSwapBuy: null,
            canUseMmg: (this === null || this === void 0 ? void 0 : this.canUseMmg) || false,
        };
        if (!isNil(opt === null || opt === void 0 ? void 0 : opt.onlyBalancePay)) {
            // console.log('1');
            if (opt === null || opt === void 0 ? void 0 : opt.onlyBalancePay) {
                // console.log('2');
                result = balanceResult;
            }
            else {
                // console.log('3');
                result = noBalanceResult;
            }
        }
        else {
            // console.log('4');
            if (this.optMemberCard) {
                // console.log('5');
                if (((_r = (_q = this.optMemberCard) === null || _q === void 0 ? void 0 : _q.recharges) === null || _r === void 0 ? void 0 : _r.length) > 0 && (opt === null || opt === void 0 ? void 0 : opt.mockCardRechargeId)) {
                    // console.log('6');
                    result = balanceResult;
                }
                else {
                    // console.log('7');
                    if (this.optMemberCard.balance >= allPrice - balanceResult.sumAllOff) {
                        // console.log('8');
                        result = balanceResult;
                    }
                    else {
                        // console.log('9');
                        result = noBalanceResult;
                    }
                }
            }
            else {
                // console.log('10');
                result = noBalanceResult;
            }
        }
        let scenes = InteractiveScenes.ORDER_SETTLEMENT;
        if (this.eatType === EatTypeEnum.Mall) {
            scenes = InteractiveScenes.MALL_ORDER_SETTLEMENT;
        }
        if ((opt === null || opt === void 0 ? void 0 : opt.isNeedNotice) && this.inited) {
            this.concessionListeners[scenes] && this.concessionListeners[scenes](null, result);
        }
        return result;
    }
    /**
     * 门店切换
     * @param storeId
     */
    switchStore(storeId) {
        if (storeId !== this.storeId) {
            if (storeId) {
                this.storeId = storeId;
                this.handleAvailableCards(false);
            }
            if (this.inited) {
                this === null || this === void 0 ? void 0 : this.reCall(true);
            }
        }
    }
    /**
     * 设置token
     * @param token
     */
    setMebToken(token) {
        this.token = token;
    }
    /**
     * 设置会员信息
     * @param member
     */
    setMemberInfo(member) {
        var _a, _b, _c, _d, _e;
        if (isEqual(member, this.originMember)) {
            return;
        }
        const lastOptMemberCard = (_a = this.optMemberCard) === null || _a === void 0 ? void 0 : _a.memberCardId;
        this.member = member;
        this.originMember = cloneDeep(member);
        if (this.member && this.member.coupons && this.member.couponsConfigMap) {
            this.setMemberCounpons(this.member.coupons, this.member.couponsConfigMap);
        }
        let sceneName = InteractiveScenes.ORDER_SETTLEMENT;
        if (this.eatType === EatTypeEnum.Mall) {
            sceneName = InteractiveScenes.MALL_ORDER_SETTLEMENT;
        }
        if (member.type === MemberTypeEnum.Member) {
            this.handleAvailableCards(((_c = (_b = this.inputDatas[sceneName]) === null || _b === void 0 ? void 0 : _b.opt) === null || _c === void 0 ? void 0 : _c.onlyBalancePay) || true);
        }
        const nowOptMemberCardId = (_d = this.optMemberCard) === null || _d === void 0 ? void 0 : _d.memberCardId;
        if (this.inputDatas && this.inputDatas[sceneName]) {
            if ((_e = this.inputDatas[sceneName].opt) === null || _e === void 0 ? void 0 : _e.mockCardRechargeId) {
                this.inputDatas[sceneName].opt = Object.assign(Object.assign({}, this.inputDatas[sceneName].opt), { mockCardRechargeId: undefined });
            }
            if (this.inputDatas[sceneName].products &&
                this.inputDatas[sceneName].products.length > 0 &&
                lastOptMemberCard !== nowOptMemberCardId) {
                each(this.inputDatas[sceneName].products, (product) => {
                    if (product.fullItemNFreeProducts) {
                        delete product.fullItemNFreeProducts;
                    }
                });
            }
        }
        return this.reCallListeners();
    }
    /**
     * 设置用户优惠券
     * @param coupons 优惠券数组
     */
    setMemberCounpons(coupons, couponsMap) {
        if (this.member) {
            const couponMap = {};
            each(coupons, (coupon) => {
                if (coupon.status === StatusEnum.Disable || coupon.endTime <= dayjs().format(DEFAULT_FORMAT)) {
                    return true;
                }
                coupon.isSelect = false;
                couponMap[coupon.memberCouponId] = coupon;
                couponsMap[coupon.couponId].productMap = {};
                each(couponsMap[coupon.couponId].products, (product) => {
                    let key = '';
                    if (product.categoryNo && !product.productNo && !product.scaleNo) {
                        key = product.categoryNo;
                    }
                    else if (product.productNo && !product.scaleNo) {
                        key = product.productNo;
                    }
                    else if (product.productNo && product.scaleNo) {
                        key = [product.productNo, product.scaleNo].join('_');
                    }
                    couponsMap[coupon.couponId].productMap[key] = product;
                });
                if (coupon.type === CouponTypeEnum.Designate) {
                    if (coupon.discountType === DiscountTypeEnum.DiscountFee) {
                        coupon.transformDiscountValue = 1 - coupon.discountValue / coupon.orderFee;
                    }
                    else {
                        coupon.transformDiscountValue = coupon.discountValue;
                    }
                }
            });
            this.member.coupons = couponMap;
        }
    }
    /**
     * 可用会员卡
     */
    handleAvailableCards(onlyBalancePay, clearMemberCard) {
        var _a, _b, _c;
        this.availableCards = [];
        const canUseCards = [];
        if (this.member && this.member.cards && (this.storeId || this.eatType === EatTypeEnum.Mall)) {
            let cards = cloneDeep(this.member.cards);
            const name = this.eatType === EatTypeEnum.Mall
                ? InteractiveScenes.MALL_ORDER_SETTLEMENT
                : InteractiveScenes.ORDER_SETTLEMENT;
            const products = ((_a = this === null || this === void 0 ? void 0 : this.inputDatas[name]) === null || _a === void 0 ? void 0 : _a.products) || [];
            let allPrice = sumBy(products, (p) => (p.price + (p.modifierPrice || 0)) * (p.cnt || 0) + (p.boxPrice || 0)) || 0;
            if (allPrice > ((_b = cards[0]) === null || _b === void 0 ? void 0 : _b.balance)) {
                allPrice = 0;
            }
            if (allPrice === 0 && (products === null || products === void 0 ? void 0 : products.length) > 0) {
                const productRes = calProduct(this, products, Object.assign(Object.assign({}, this.inputDatas[name].opt), { isOrder: true }));
                each(products, (product) => {
                    const item = productRes.itemMap[product.pk || ''];
                    if (item) {
                        if (item.off) {
                            allPrice +=
                                (product.price + (product.modifierPrice || 0)) * (product.cnt || 0) +
                                    (product.boxPrice || 0) -
                                    item.off;
                        }
                        else if (item.memberPrice) {
                            allPrice += item.memberPrice * (product.cnt || 0) + (product.boxPrice || 0);
                        }
                        else {
                            allPrice += (product.price + (product.modifierPrice || 0)) * (product.cnt || 0) + (product.boxPrice || 0);
                        }
                    }
                    else {
                        allPrice += (product.price + (product.modifierPrice || 0)) * (product.cnt || 0) + (product.boxPrice || 0);
                    }
                });
            }
            each(cards, (card) => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                if ((this.eatType !== EatTypeEnum.Mall &&
                    (card.isAllStore || (card.storeIds && card.storeIds.includes(this.storeId)))) ||
                    this.eatType === EatTypeEnum.Mall) {
                    if ((this.eatType === EatTypeEnum.Mall && (((_a = card.extra) === null || _a === void 0 ? void 0 : _a.mallNoBalanceNoDiscount) || !card.mallDiscountType)) ||
                        (this.eatType !== EatTypeEnum.Mall &&
                            (((_b = card.extra) === null || _b === void 0 ? void 0 : _b.balanceDiscountRule) === BalanceDiscountRuleEnum.HasBalance ||
                                ((_c = card.extra) === null || _c === void 0 ? void 0 : _c.balanceDiscountRule) === BalanceDiscountRuleEnum.OnlyBalancePay))) {
                        if (((!card.balance || card.balance <= 0) &&
                            ((_d = card.extra) === null || _d === void 0 ? void 0 : _d.balanceDiscountRule) === BalanceDiscountRuleEnum.HasBalance &&
                            !onlyBalancePay) ||
                            (!onlyBalancePay &&
                                ((_e = card.extra) === null || _e === void 0 ? void 0 : _e.balanceDiscountRule) === BalanceDiscountRuleEnum.OnlyBalancePay &&
                                allPrice > card.balance) ||
                            (((_f = card.extra) === null || _f === void 0 ? void 0 : _f.balanceDiscountRule) === BalanceDiscountRuleEnum.OnlyBalancePay &&
                                (((_g = card === null || card === void 0 ? void 0 : card.recharges) === null || _g === void 0 ? void 0 : _g.length) <= 0 || !(card === null || card === void 0 ? void 0 : card.recharges)) &&
                                allPrice > card.balance) ||
                            clearMemberCard) {
                            //手动设置没有权益
                            card.discountType = DiscountTypeEnum.DiscountFee;
                            card.discountValue = 0;
                            if (this.eatType === EatTypeEnum.Mall) {
                                card.mallProductRelation = '';
                            }
                            else {
                                card.productRelation = '';
                            }
                        }
                    }
                    (_h = this.availableCards) === null || _h === void 0 ? void 0 : _h.push(card.cardId);
                    canUseCards.push(card);
                }
            });
            if (this.eatType === EatTypeEnum.Mall) {
                cards = orderBy(canUseCards, 'mallDiscountValue', 'asc');
            }
            else {
                cards = orderBy(canUseCards, 'discountValue', 'asc');
            }
            this.optMemberCard = cards[0] || null;
            if (this.optMemberCard && this.eatType === EatTypeEnum.Mall) {
                this.optMemberCard.discountType = this.optMemberCard.mallDiscountType || '';
                this.optMemberCard.discountValue = this.optMemberCard.mallDiscountValue || 0;
                this.optMemberCard.integralMoney = this.optMemberCard.mallIntegralMoney || 0;
                this.optMemberCard.integralCostMoney = this.optMemberCard.mallIntegralCostMoney || 1;
                this.optMemberCard.integralMoneyMax = this.optMemberCard.mallIntegralMoneyMax || 0;
                this.optMemberCard.integralMoneyMaxType = this.optMemberCard.mallIntegralMoneyMaxType || '';
                this.optMemberCard.products = this.optMemberCard.mallProducts;
                this.optMemberCard.productRelation = this.optMemberCard.mallProductRelation;
            }
            if (this.optMemberCard) {
                this.optMemberCard.products && (this.optMemberCard.productMap = prodctToMap(this.optMemberCard.products));
                if (((_c = this.optMemberCard) === null || _c === void 0 ? void 0 : _c.expireTime) && this.optMemberCard.expireTime <= dayjs().format(DEFAULT_FORMAT)) {
                    this.optMemberCard.discountType = '';
                    this.optMemberCard.isExpired = true;
                }
                else {
                    this.optMemberCard.isExpired = false;
                }
            }
            this.getRechargeCouponByIds();
        }
    }
    /**
     * 清除会员信息
     */
    clearMemberInfo() {
        this.member = null;
        this.optMemberCard = null;
        this.availableCards = [];
        this.originMember = null;
        this.reCallListeners();
    }
    /**
     * 获取会员信息
     */
    getMemberInfo() {
        return this.member;
    }
    /**
     * 加密 sk
     * @param data
     */
    genSK(data = {}) {
        data.created = dayjs().valueOf();
        /**
         * created 加密时间
         */
        return aes.encrypt(data);
    }
    /**
     * 门店的手动方案
     */
    storePlan(result) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!result) {
                try {
                    const res = yield request.get(this.getServiceUrl() + '/pos/storePlan', {
                        params: { brandId: this.brandId, storeId: this.storeId || 0, appType: this.appType },
                        headers: this.getRequestHeaders(),
                    });
                    result = res === null || res === void 0 ? void 0 : res.result;
                }
                catch (e) {
                    console.error('get pos/storePlan error', e);
                    this.orderPlan = JSON.parse(storage.getItem(MMG_ORDER_PLAN) || '');
                    this.productPlan = JSON.parse(storage.getItem(MMG_PRODUCT_PLAN) || '');
                }
            }
            this.orderPlan = (result === null || result === void 0 ? void 0 : result.orderPlan) || {};
            this.productPlan = (result === null || result === void 0 ? void 0 : result.productPlan) || {};
            storage.setItem(MMG_ORDER_PLAN, JSON.stringify(this.orderPlan));
            storage.setItem(MMG_PRODUCT_PLAN, JSON.stringify(this.productPlan));
            if (this.productPlan) {
                each(this.productPlan.tags, (tag) => {
                    const productMap = {}; // key value
                    each(tag.products, (product) => {
                        let id = '';
                        if (product.categoryNo && !product.productNo && !product.scaleNo) {
                            id = product.categoryNo;
                        }
                        else if (product.productNo && !product.scaleNo) {
                            id = product.productNo;
                        }
                        else if (product.productNo && product.scaleNo) {
                            id = [product.productNo, product.scaleNo].join('_');
                        }
                        productMap[id] = product;
                    });
                    tag.productMap = productMap;
                });
            }
        });
    }
    /**
     * 添加定时器任务
     * @param time
     */
    addTimeout(time) {
        if (time.length <= 16) {
            time = time + ':00';
        }
        const timeValueOf = dayjs(time).valueOf();
        // 大于2天不用加定时器任务
        if (timeValueOf > dayjs().add(2, 'd').valueOf()) {
            return;
        }
        if (!this.timeouts) {
            this.timeouts = {};
        }
        if (this.timeouts[time]) {
            return;
        }
        const ms = timeValueOf - dayjs().valueOf();
        if (ms <= 0) {
            return;
        }
        const id = setTimeout(() => {
            try {
                this === null || this === void 0 ? void 0 : this.reCall(true);
            }
            catch (err) {
                console.warn('reCall error', err);
            }
        }, ms);
        this.timeouts[time] = id;
    }
    /**
     * 清空定时器任务
     */
    clearTimeout() {
        each(this.timeouts, (id, time) => {
            clearTimeout(id);
            delete this.timeouts[time];
        });
    }
    /**
     * 获取 timeout 任务
     * @returns
     */
    getTimeout() {
        return this.timeouts;
    }
    /**
     * 优惠码检查
     * @param promoCode
     */
    checkPromoCode(promoCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield request.post(this.getServiceUrl() + '/activity/usePromoCodeFindActivity', { brandId: this.brandId, storeId: this.storeId || 0, promoCode }, { headers: this.getRequestHeaders() });
            const promoCodeActivity = res === null || res === void 0 ? void 0 : res.result;
            let status = StatusEnum.Disable;
            each(this.activities, (activity) => {
                if (activity.promoCode) {
                    if (activity.promoCode === promoCode) {
                        status = StatusEnum.Enable;
                        return;
                    }
                }
                if (promoCodeActivity && activity.activityId === promoCodeActivity.activityId) {
                    status = StatusEnum.Enable;
                    activity.promoCode = aes.decrypt(promoCodeActivity.promoCode);
                    return;
                }
            });
            return { status };
        });
    }
    /**
     * 获取最优的会员卡
     */
    getOptMemberCard() {
        return this.optMemberCard;
    }
    /**
     * 获取最优的会员卡
     */
    setOptMemberCard(memberCard) {
        this.optMemberCard = memberCard;
        this.optMemberCard.products && (this.optMemberCard.productMap = prodctToMap(this.optMemberCard.products));
    }
    /**
     * 获取会员价
     * @param sync boolean 是否同步
     * @param result any 请求结果
     */
    getMemberPrice(sync = false, result) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (!result) {
                try {
                    let url = this.getServiceUrl() +
                        `/pos/memberPrice?brandId=${this.brandId}&storeId=${this.storeId}&appType=${this.appType}`;
                    if (this.eatType === EatTypeEnum.Mall) {
                        url += '&type=mall';
                    }
                    const res = yield request.get(url, {
                        headers: this.getRequestHeaders(),
                    });
                    result = res === null || res === void 0 ? void 0 : res.result;
                }
                catch (e) {
                    traceLog({
                        name: '获取会员价异常',
                        message: { brandId: this.brandId, storeId: this.storeId, eatType: this.eatType, error: e },
                    });
                }
            }
            if (result) {
                if (this.eatType === EatTypeEnum.Mall) {
                    this.mallMemberPriceMap = result.productMap;
                    this.mallMemberPricePlanName = result.memberPricePlanName;
                    this.mallMemberPricePlanId = result.memberPricePlanId;
                }
                else {
                    this.memberPriceMap = result.productMap;
                    this.memberPricePlanName = result.memberPricePlanName;
                    this.memberPricePlanId = result.memberPricePlanId;
                }
                const name = this.eatType === EatTypeEnum.Mall
                    ? InteractiveScenes.MALL_ORDER_SETTLEMENT
                    : InteractiveScenes.ORDER_SETTLEMENT;
                this.handleAvailableCards(((_b = (_a = this === null || this === void 0 ? void 0 : this.inputDatas[name]) === null || _a === void 0 ? void 0 : _a.opt) === null || _b === void 0 ? void 0 : _b.onlyBalancePay) || true);
                if (sync && this.inputDatas[name].products) {
                    calProduct(this, this.inputDatas[name].products, this.inputDatas[name].opt);
                }
            }
            if (!this.memberPriceMap || isEmpty(this.memberPriceMap)) {
                traceLog({
                    name: '没有会员价',
                    message: { brandId: this.brandId, storeId: this.storeId, eatType: this.eatType },
                    upload: false,
                });
            }
        });
    }
    /**
     * 接口联合查询
     */
    combineRequest() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield request.get(this.getServiceUrl() + '/pos/combine', {
                params: { brandId: this.brandId, storeId: this.storeId || 0, eatType: this.eatType, appType: this.appType },
                headers: this.getRequestHeaders(),
            });
            const result = res === null || res === void 0 ? void 0 : res.result;
            if (!result) {
                return;
            }
            this.storePlan(result === null || result === void 0 ? void 0 : result.plans);
            this.refreshActivity(false, result === null || result === void 0 ? void 0 : result.activities);
            if (result === null || result === void 0 ? void 0 : result.memberPrice) {
                this.memberPriceMap = result.memberPrice.productMap;
                this.memberPricePlanName = result.memberPrice.memberPricePlanName;
                this.memberPricePlanId = result.memberPrice.memberPricePlanId;
                this.onlyInSideMemberPrice = result.memberPrice.onlyInSideMemberPrice;
            }
            if (result === null || result === void 0 ? void 0 : result.mallMemberPrice) {
                this.mallMemberPriceMap = result.mallMemberPrice.productMap;
                this.mallMemberPricePlanName = result.mallMemberPrice.memberPricePlanName;
                this.mallMemberPricePlanId = result.mallMemberPrice.memberPricePlanId;
                this.mallOnlyInSideMemberPrice = result.memberPrice.mallOnlyInSideMemberPrice;
            }
            this.getMemberPrice(false, this.eatType === EatTypeEnum.Mall ? result === null || result === void 0 ? void 0 : result.mallMemberPrice : result === null || result === void 0 ? void 0 : result.memberPrice);
            this.getMarketingConfig(result === null || result === void 0 ? void 0 : result.config);
        });
    }
    /**
     * 所有优惠刷新
     */
    refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.combineRequest();
            this.reCallListeners();
        });
    }
    /**
     * 获取promoCode活动
     * @param promoCodes
     */
    getPromoCodeActivies(promoCodes, enablePromoCodeActivity) {
        const promoCodeActivies = [];
        if (promoCodes.length > 0) {
            each(this.activities, (activity) => {
                if (activity.promoCode) {
                    if (promoCodes.includes(activity.promoCode)) {
                        promoCodeActivies.push(Object.assign(Object.assign({}, activity), { status: enablePromoCodeActivity.includes(activity.activityId) ? StatusEnum.Enable : StatusEnum.Disable }));
                    }
                }
            });
        }
        return promoCodeActivies;
    }
    /**
     * 获取营销配置
     * @param result
     */
    getMarketingConfig(result) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!result) {
                const res = yield request.get(this.getServiceUrl() + '/pos/config', {
                    params: { brandId: this.brandId, storeId: this.storeId || 0, appType: this.appType },
                    headers: this.getRequestHeaders(),
                });
                result = res === null || res === void 0 ? void 0 : res.result;
            }
            this.config = result;
        });
    }
    /**
     * 算获取的积分
     * @param orderPrice
     */
    getIntegral(orderPrice) {
        var _a, _b, _c, _d;
        let integral = 0;
        if ((this === null || this === void 0 ? void 0 : this.optMemberCard) && ((_a = this.optMemberCard) === null || _a === void 0 ? void 0 : _a.isIntegral) && !((_b = this.optMemberCard) === null || _b === void 0 ? void 0 : _b.isExpired) && orderPrice > 0) {
            let costMoney = this.optMemberCard.costMoney || 0;
            let getIntegral = this.optMemberCard.getIntegral || 0;
            if (this.eatType === EatTypeEnum.Mall) {
                costMoney = ((_c = this.optMemberCard) === null || _c === void 0 ? void 0 : _c.mallCostMoney) || 0;
                getIntegral = ((_d = this.optMemberCard) === null || _d === void 0 ? void 0 : _d.mallGetIntegral) || 0;
            }
            if (!getIntegral || !costMoney) {
                return 0;
            }
            integral = floor(orderPrice / costMoney) * getIntegral;
            if (isNaN(integral)) {
                integral = 0;
            }
        }
        return integral;
    }
    getRequestHeaders() {
        var _a, _b;
        let session_id = '';
        if (typeof sessionStorage !== 'undefined') {
            session_id = sessionStorage.getItem('_bl_sid') || '';
        }
        return Object.assign(Object.assign({}, ((typeof window !== 'undefined' && (window === null || window === void 0 ? void 0 : window.signMaker) && window.signMaker()) || {})), { brandid: ((_a = this.brandId) === null || _a === void 0 ? void 0 : _a.toString()) || '', storeid: ((_b = this.storeId) === null || _b === void 0 ? void 0 : _b.toString()) || '', userPoint: this.userPoint || 'normal', session_id, appVersion: (this === null || this === void 0 ? void 0 : this.appVersion) || '' });
    }
    /**
     * 获取充值的优惠券数据
     */
    getRechargeCouponByIds() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isGetRechargeCouponByIds && ((_a = this.optMemberCard) === null || _a === void 0 ? void 0 : _a.recharges) && ((_b = this.optMemberCard) === null || _b === void 0 ? void 0 : _b.recharges.length) > 0) {
                this.isGetRechargeCouponByIds = true;
                const couponIds = [];
                let coupons = [];
                each(this.optMemberCard.recharges, (recharge) => {
                    var _a;
                    if (((_a = recharge === null || recharge === void 0 ? void 0 : recharge.coupons) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        each(recharge.coupons, (coupon) => {
                            var _a, _b, _c;
                            if ((((_a = this === null || this === void 0 ? void 0 : this.member) === null || _a === void 0 ? void 0 : _a.mockCouponMap) && !((_b = this === null || this === void 0 ? void 0 : this.member) === null || _b === void 0 ? void 0 : _b.mockCouponMap[coupon.couponId])) ||
                                !((_c = this === null || this === void 0 ? void 0 : this.member) === null || _c === void 0 ? void 0 : _c.mockCouponMap)) {
                                couponIds.push(coupon.couponId);
                            }
                        });
                    }
                });
                if (couponIds.length > 0) {
                    try {
                        const res = yield request.post(this.getServiceUrl() + '/coupon/getCouponByIds', {
                            brandId: this.brandId,
                            couponIds: couponIds,
                        }, {
                            headers: this.getRequestHeaders(),
                        });
                        coupons = res === null || res === void 0 ? void 0 : res.result;
                    }
                    catch (e) {
                        console.error('get coupon/getCouponByIds error', e);
                    }
                }
                if (coupons && (coupons === null || coupons === void 0 ? void 0 : coupons.length) > 0) {
                    each(coupons, (coupon) => {
                        var _a;
                        if ((_a = this.member) === null || _a === void 0 ? void 0 : _a.couponsConfigMap) {
                            const productMap = {};
                            each(coupon.products, (product) => {
                                let key = '';
                                if (product.categoryNo && !product.productNo && !product.scaleNo) {
                                    key = product.categoryNo;
                                }
                                else if (product.productNo && !product.scaleNo) {
                                    key = product.productNo;
                                }
                                else if (product.productNo && product.scaleNo) {
                                    key = [product.productNo, product.scaleNo].join('_');
                                }
                                productMap[key] = product;
                            });
                            const storeIds = [];
                            each(coupon.stores, (store) => {
                                storeIds.push(store.storeId);
                            });
                            delete coupon.stores;
                            if (!this.member.mockCouponMap) {
                                this.member.mockCouponMap = {};
                            }
                            this.member.mockCouponMap[coupon.couponId] = coupon;
                            this.member.couponsConfigMap[coupon.couponId] = {
                                // ...coupon,
                                products: coupon.products,
                                productMap: productMap,
                                stores: coupon.stores,
                                extra: coupon.extra,
                                storeIds: storeIds,
                                couponId: coupon.couponId,
                            };
                        }
                    });
                }
            }
            setTimeout(() => {
                this.isGetRechargeCouponByIds = false;
            }, 200);
        });
    }
    /**
     * 切换 proxyHost
     * @param proxyHost
     */
    switchProxyHost(proxyHost) {
        isString(this.proxyHost) && (this.proxyHost = proxyHost);
    }
}
//# sourceMappingURL=mpc.js.map